import {Component, EventEmitter, Inject, OnInit, Output, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ConfService} from '../conf.service';
import {environment} from '../../environments/environment';
import {ConnecttocrudService} from '../connecttocrud.service';
import {KongService} from '../kong.service';
import {SnackbarComponent} from '../snackbar/snackbar.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {AccountInfoService} from '../user/account-info.service';
import {ListenerService} from '../listener.service';
import {AuthService} from '../user/auth.service';
import {Router} from '@angular/router';
import {AppComponent} from '../app.component';
import {Location} from '@angular/common';
import {InsufficientPermissionsToAccessComponent} from '../leftpanel/leftpanel.component';
import {AdminEnvironmentHandlerService} from '../admin-environment-handler.service';


export interface Menu {
  display_name: string;
  name: string;
  iconClass: string;
  active: boolean;
  toolTip: string;
  route: string;
  submenu: { name: string, key: string, icon: string, toolTip: string, route: string, submenu: {name: string, key: string, icon: string, toolTip: string, route: string}[] }[];
}

@Component({
  selector: 'app-leftpanel-new',
  templateUrl: './leftpanel-new.component.html',
  styleUrls: ['./leftpanel-new.component.css']
})
export class LeftpanelNewComponent implements OnInit {
  keySize = 128;
  databasesMeta: any;
  databasesMetaDefault = [
    {
      'database_name': '',
      'display_name': 'MongoDB',
      'image': './assets/img/partnerOnboarding/mongoDB.png',
      'database_type': 'mongodb',
      'is_nosql': true,
      'database_attributes': [
        {
          'name': 'username',
          'display_name': 'Username',
          'description': '',
          'required': false
        },
        {
          'name': 'password',
          'display_name': 'Password',
          'description': '',
          'required': false
        },
        {
          'name': 'host',
          'display_name': 'Host',
          'description': '',
          'required': true
        },
        {
          'name': 'port',
          'display_name': 'Port',
          'description': '',
          'required': false
        },
        {
          'name': 'dbName',
          'display_name': 'Database Name',
          'description': '',
          'required': true
        },
        {
          'name': 'connectionString',
          'display_name': 'Connection String',
          'description': '',
          'required': false
        },
      ]
    },
    {
      'database_name': '',
      'database_type': 'dynamodb',
      'display_name': 'DynamoDB',
      'image': './assets/img/partnerOnboarding/dynamoDB.png',
      'is_nosql': true,
      'database_attributes': [
        {
          'name': 'access_key',
          'display_name': 'Access Key',
          'description': '',
          'required': true
        },
        {
          'name': 'secret_key',
          'display_name': 'Secret Key',
          'description': '',
          'required': true
        },
        {
          'name': 'region',
          'display_name': 'Region',
          'description': '',
          'required': false
        }
      ]
    },
    {
      'database_name': '',
      'database_type': 'csv',
      'display_name': 'CSV',
      'is_default': false,
      'is_nosql': false,
      'database_attributes': [
        {
          'name': 'url',
          'display_name': 'Url',
          'description': '',
          'required': true
        },
        {
          'name': 'name',
          'display_name': 'Name',
          'description': '',
          'required': true
        },
        {
          'name': 'separator',
          'display_name': 'Separator',
          'description': '',
          'required': false
        }
      ]

    },
    {
      'database_name': '',
      'database_type': 'oracle',
      'display_name': 'Oracle',
      'image': './assets/img/partnerOnboarding/oracle.png',
      'is_nosql': false,
      'database_attributes': [
        {
          'name': 'username',
          'display_name': 'Username',
          'description': '',
          'required': false
        },
        {
          'name': 'password',
          'display_name': 'Password',
          'description': '',
          'required': false
        },
        {
          'name': 'host',
          'display_name': 'Host',
          'description': '',
          'required': true
        },
        {
          'name': 'port',
          'display_name': 'Port',
          'description': '',
          'required': false
        },
        {
          'name': 'dbName',
          'display_name': 'Database Name',
          'description': '',
          'required': true
        },
        {
          'name': 'connectionString',
          'display_name': 'Connection String',
          'description': '',
          'required': false
        },
      ]
    },
    {
      'database_name': '',
      'database_type': 'mysql',
      'display_name': 'MySQL',
      'image': './assets/img/partnerOnboarding/mySQL.png',
      'is_nosql': false,
      'database_attributes': [
        {
          'name': 'username',
          'display_name': 'Username',
          'description': '',
          'required': false
        },
        {
          'name': 'password',
          'display_name': 'Password',
          'description': '',
          'required': false
        },
        {
          'name': 'host',
          'display_name': 'Host',
          'description': '',
          'required': true
        },
        {
          'name': 'port',
          'display_name': 'Port',
          'description': '',
          'required': false
        },
        {
          'name': 'dbName',
          'display_name': 'Database Name',
          'description': '',
          'required': true
        },
        {
          'name': 'connectionString',
          'display_name': 'Connection String',
          'description': '',
          'required': false
        },
      ]
    },
    {
      'database_name': '',
      'database_type': 'sqlserver',
      'display_name': 'MS SQL Server',
      'image': './assets/img/partnerOnboarding/msSQL.jpg',
      'is_nosql': false,
      'database_attributes': [
        {
          'name': 'username',
          'display_name': 'Username',
          'description': '',
          'required': false
        },
        {
          'name': 'password',
          'display_name': 'Password',
          'description': '',
          'required': false
        },
        {
          'name': 'host',
          'display_name': 'Host',
          'description': '',
          'required': true
        },
        {
          'name': 'port',
          'display_name': 'Port',
          'description': '',
          'required': false
        },
        {
          'name': 'dbName',
          'display_name': 'Database Name',
          'description': '',
          'required': true
        },
        {
          'name': 'connectionString',
          'display_name': 'Connection String',
          'description': '',
          'required': false
        },
      ]
    },
    {
      'database_name': '',
      'database_type': 'postgresql',
      'display_name': 'PostgreSQL',
      'image': './assets/img/partnerOnboarding/postgreySQL.png',
      'is_nosql': false,
      'database_attributes': [
        {
          'name': 'username',
          'display_name': 'Username',
          'description': '',
          'required': false
        },
        {
          'name': 'password',
          'display_name': 'Password',
          'description': '',
          'required': false
        },
        {
          'name': 'host',
          'display_name': 'Host',
          'description': '',
          'required': true
        },
        {
          'name': 'port',
          'display_name': 'Port',
          'description': '',
          'required': false
        },
        {
          'name': 'dbName',
          'display_name': 'Database Name',
          'description': '',
          'required': true
        },
        {
          'name': 'connectionString',
          'display_name': 'Connection String',
          'description': '',
          'required': false
        },
      ]
    },
    {
      'database_name': '',
      'database_type': 'cosmosdb',
      'display_name': 'CosmosDB',
      'image': './assets/img/partnerOnboarding/cosmosDB.png',
      'is_nosql': false,
      'database_attributes': [
        {
          'name': 'accountName',
          'display_name': 'Account Name',
          'description': '',
          'required': true
        },
        {
          'name': 'accountKey',
          'display_name': 'Account Key',
          'description': '',
          'required': true
        },
        {
          'name': 'tableEndpoint',
          'display_name': 'Table Endpoint',
          'description': '',
          'required': false
        },
        {
          'name': 'endpointProtocol',
          'display_name': 'Endpoint Protocol',
          'description': '',
          'required': false
        }
      ]
    },
    {
      'database_name': '',
      'database_type': 'aurora-mysql',
      'display_name': 'Aurora (MySQL)',
      'image': './assets/img/partnerOnboarding/aurora.png',
      'is_nosql': false,
      'database_attributes': [
        {
          'name': 'username',
          'display_name': 'Username',
          'description': '',
          'required': false
        },
        {
          'name': 'password',
          'display_name': 'Password',
          'description': '',
          'required': false
        },
        {
          'name': 'host',
          'display_name': 'Host',
          'description': '',
          'required': true
        },
        {
          'name': 'port',
          'display_name': 'Port',
          'description': '',
          'required': false
        },
        {
          'name': 'dbName',
          'display_name': 'Database Name',
          'description': '',
          'required': true
        },
        {
          'name': 'connectionString',
          'display_name': 'Connection String',
          'description': '',
          'required': false
        },
      ]
    },
    {
      'database_name': '',
      'database_type': 'aurora-postgresql',
      'display_name': 'Aurora (Postgresql)',
      'image': './assets/img/partnerOnboarding/aurora.png',
      'is_nosql': false,
      'database_attributes': [
        {
          'name': 'username',
          'display_name': 'Username',
          'description': '',
          'required': false
        },
        {
          'name': 'password',
          'display_name': 'Password',
          'description': '',
          'required': false
        },
        {
          'name': 'host',
          'display_name': 'Host',
          'description': '',
          'required': true
        },
        {
          'name': 'port',
          'display_name': 'Port',
          'description': '',
          'required': false
        },
        {
          'name': 'dbName',
          'display_name': 'Database Name',
          'description': '',
          'required': true
        },
        {
          'name': 'connectionString',
          'display_name': 'Connection String',
          'description': '',
          'required': false
        },
      ]
    },
    {
      'database_name': '',
      'database_type': 'snowflake',
      'display_name': 'Snowflake',
      'image': './assets/img/partnerOnboarding/snowflake.png',
      'is_nosql': false,
      'database_attributes': [
        {
          'name': 'account_name',
          'display_name': 'Account Name',
          'description': '',
          'required': true
        },
        {
          'name': 'user',
          'display_name': 'User',
          'description': '',
          'required': false
        },
        {
          'name': 'password',
          'display_name': 'Password',
          'description': '',
          'required': false
        },
        {
          'name': 'authenticator',
          'display_name': 'Authenticator',
          'description': '',
          'required': false
        },
        {
          'name': 'token',
          'display_name': 'Token',
          'description': '',
          'required': false
        },
        {
          'name': 'role',
          'display_name': 'Role',
          'description': '',
          'required': false
        },
        {
          'name': 'db',
          'display_name': 'Database',
          'description': '',
          'required': false
        },
        {
          'name': 'schema',
          'display_name': 'Schema',
          'description': '',
          'required': false
        },
        {
          'name': 'warehouse',
          'display_name': 'Warehouse',
          'description': '',
          'required': false
        },
        {
          'name': 'tracing',
          'display_name': 'Tracing',
          'description': '',
          'required': false
        },
        {
          'name': 'passcode',
          'display_name': 'Passcode',
          'description': '',
          'required': false
        },
        {
          'name': 'passcodeInPassword',
          'display_name': 'Passcode In Password',
          'description': '',
          'required': false
        },
        {
          'name': 'loginTimeout',
          'display_name': 'Login Timeout',
          'description': '',
          'required': false
        },
        {
          'name': 'networkTimeout',
          'display_name': 'Network Timeout',
          'description': '',
          'required': false
        },
        {
          'name': 'queryTimeout',
          'display_name': 'Query Timeout',
          'description': '',
          'required': false
        },
        {
          'name': 'application',
          'display_name': 'Application',
          'description': '',
          'required': false
        },
        {
          'name': 'disableSocksProxy',
          'display_name': 'Disable Socks Proxy',
          'description': '',
          'required': false
        },
        {
          'name': 'stringsQuotedForColumnDef',
          'display_name': 'Strings Quoted For Column Def',
          'description': '',
          'required': false
        },
        {
          'name': 'CLIENT_SESSION_KEEP_ALIVE',
          'display_name': 'CLIENT_SESSION_KEEP_ALIVE',
          'description': '',
          'required': false
        },
        {
          'name': 'connectionString',
          'display_name': 'Connection String',
          'description': '',
          'required': false
        },
      ]
    }
  ];
  currentSession: any;
  actionsOfCurrentSession = [];
  userName: string;
  searchText: string;
  route: any;
  SideMenuNavigationUrl: string;
  basicPermission: boolean;
  settingsflag: any;
  subMenu = false;
  selectedMenu: any;
  JSONData: any = {};
  categories = [];

  partnerLogo: any;
  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');
  gatewayUrl: any;
  defaultGatewayURL: any;
  settingsData: any;
  availableEnvironmentsToSwitch: any;
  environments = [];

  masterData = [
    {
      'category': 'controlplane',
      'route': '/controlplane',
      'expand': false
    },
    {
      'category': 'infrastructure',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Environments',
          route: '/environments',
          icon: 'fa fa-code-fork'
        },
        {
          categoryName: 'Secrets Managers',
          route: '/secret-manager',
          icon: 'fa fa-user-secret'
        },
        {
          categoryName: 'Gateway Managers',
          route: '/api-gateway',
          icon: 'fa fa-shield'
        },
        {
          categoryName: 'Databases',
          route: '/databases',
          icon: 'fa fa-database'
        }
      ]
    },
    {
      'category': 'authorization',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Roles',
          route: '/roles',
          icon: 'fa fa-id-card-o'
        },
        {
          categoryName: 'Permission Groups',
          route: '/permissiongroup',
          icon: 'fa fa-key'
        },
        {
          categoryName: 'Permissions',
          route: '/permissions',
          icon: 'fa fa-id-badge'
        },
        {
          categoryName: 'User Groups',
          route: '/usergroups',
          icon: 'fa fa-users'
        },
        {
          categoryName: 'Users',
          route: '/users',
          icon: 'fa fa-user'
        }
      ]
    },
    {
      'category': 'environments',
      'expand': true,
      'route': null,
      'subcategory': [
      ],
    },
    {
      'category': 'partner settings',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Business Locations',
          route: '/businesslocations',
          icon: 'fa fa-globe'
        },
        {
          categoryName: 'Business Details',
          route: '/businessdetails',
          icon: 'fa fa-building-o'
        },
        {
          categoryName: 'Branding',
          route: '/branding',
          icon: 'fa fa-id-badge'
        },
      ]
    },
    {
      'category': 'billing',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Billing',
          route: '/billing',
          icon: 'fa fa-usd'
        },
        {
          categoryName: 'Coupons',
          route: '/coupon-management',
          icon: 'fa fa-money'
        },
        {
          categoryName: 'Credits',
          route: '/credits',
          icon: 'fa fa-credit-card'
        }
      ]
    },
    {
      'category': 'creation',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Data as a Service',
          route: '/dataaccessapi',
          icon: 'fa fa-table'
        },
        {
          categoryName: 'Data as a Service (Advanced)',
          route: '/dataaccessapi-advanced',
          icon: 'fa fa-table'
        },
        {
          categoryName: 'Application Logic',
          route: '/businesslogic',
          icon: 'fa fa-link'
        },
        {
          categoryName: 'Workflows',
          route: '/workflow',
          icon: 'fa fa-sitemap'
        },
        {
          categoryName: 'Decisions',
          route: '/dmn',
          icon: 'fa fa-codepen'
        },
        {
          categoryName: 'SQL as a Service',
          route: '/querybuilder',
          icon: 'fa fa-database'
        },
        {
          categoryName: 'PLSQL as a Service',
          route: '/plsql',
          icon: 'fa fa-tasks'
        },
        {
          categoryName: 'API Joins',
          route: '/unified-query-builder',
          icon: 'fa fa-server'
        },
        {
          categoryName: 'API Collections',
          route: '/collections',
          icon: 'fa fa-object-group'
        },
        {
          categoryName: 'Test Suite as a Service',
          route: '/testsuite',
          icon: 'fa fa-check-circle-o'
        }
      ]
    },
    {
      'category': 'connect',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'API Providers',
          route: '/providers',
          icon: 'fa fa-table'
        },
        {
          categoryName: 'API Provider Categories',
          route: '/provider-category',
          icon: 'fa fa-table'
        },
        {
          categoryName: 'Accelerators',
          route: '/accelerators',
          icon: 'send_time_extension',
          iconType: 'mat-icon'
        },
        {
          categoryName: 'Database Connectors',
          route: '/databases',
          icon: 'fa fa-database'
        },
        {
          categoryName: 'API Register',
          route: '/api-register',
          icon: 'fa fa-book'
        },
        {
          categoryName: 'Postman Collection',
          route: '/postman-collections',
          icon: 'fa fa-rocket'
        },
      ]
    },
    {
      'category': 'transform',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Design2API',
          route: '/application',
          icon: 'fa fa-table'
        },
        {
          categoryName: 'Data2API',
          route: '/datacatalog',
          icon: 'fa fa-table'
        },
        {
          categoryName: 'COBOL2API',
          route: '/coboltoapi',
          icon: 'fa fa-table'
        },
        {
          categoryName: 'Data Transformation',
          route: '/transform',
          icon: 'fa fa-database'
        },
      ]
    },
    {
      'category': 'reference',
      'route': '/docs',
      'expand': false
    },
    {
      'category': 'test',
      'route': '/devex',
      'expand': false,
      'subcategory': [
        {
          categoryName: 'API Tester',
          route: '/devex',
          icon: 'fa fa-rocket'
        },
        {
          categoryName: 'Test Suite',
          route: '/testsuite',
          icon: 'fa fa-check-circle-o'
        },
        {
          categoryName: 'Test Suite Results',
          route: '/test-results',
          icon: 'fa fa-graduation-cap'
        },
        {
          categoryName: 'APIQL Engine',
          route: '/apiql',
          icon: 'fa fa-cubes'
        },
        {
          categoryName: 'DATAQL Engine',
          route: '/dataql',
          icon: 'fa fa-database'
        },
        {
          categoryName: 'API Collection',
          route: '/collection',
          icon: 'fa fa-list-alt'
        }
      ]
    },
    {
      'category': 'manage',
      'expand': true,
      'route': null,
      'subcategory': []
    },
    {
      'category': 'tools',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Email Template Builder',
          // route: '/emailtemplatebuilder',
          route: '/email-templates',
          icon: 'fa fa-envelope'
        },
        {
          categoryName: 'Scheduler',
          route: '/scheduler',
          icon: 'fa fa-calendar'
        },
        {
          categoryName: 'Trigger',
          route: '/trigger',
          icon: 'fa fa-bolt'
        },
        {
          categoryName: 'Data Catalog',
          route: '/datacatalog',
          icon: 'fa fa-book',
        },
        {
          categoryName: 'File Manager',
          route: '/filestorage',
          icon: 'fa fa-hdd-o'
        },
      ]
    },
    {
      'category': 'Data Access API',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          'categoryName': 'Data Access API',
          'route': null
        }
      ]
    },
    {
      'category': 'Settings',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          'categoryName': 'Business Details',
          'route': '/businessdetails'
        },
        {
          'categoryName': 'Branding',
          'route': '/branding'
        },
        {
          'categoryName': 'API Keys',
          'route': '/api-key'
        },
        {
          'categoryName': 'Business Locations',
          'route': '/businesslocations'
        },
        {
          'categoryName': 'Dashboard',
          'route': '/dashboard'
        },
        {
          'categoryName': 'Databases',
          'route': '/databases'
        },
        {
          'categoryName': 'Metrics',
          'route': '/metrics'
        },
        {
          'categoryName': 'IP Restrictions',
          'route': '/ipconfig'
        },
        {
          'categoryName': 'Identity Manager',
          'route': '/identitymanager'
        },
        {
          'categoryName': 'Credits',
          'route': '/credits'
        }
      ]
    },
    {
      'category': 'Billing',
      'route': '/billing',
      'expand': false
    },
    {
      'category': 'logout',
      'route': null,
      'expand': false
    },
    {
      'category': 'identity and access management',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Platform Console',
          route: '',
          icon: 'fa fa-globe'
        },
        {
          categoryName: 'Developer Experience',
          route: '/businessdetails',
          icon: 'fa fa-building-o'
        },
        {
          categoryName: 'API Gateway',
          route: '/usergroups',
          icon: 'fa fa-id-badge'
        },
        {
          categoryName: 'File Storage',
          route: '/themes',
          icon: 'fa fa-themeisle'
        },
        {
          categoryName: 'Databases',
          route: '/permissions',
          icon: 'fa fa-shield'
        }
      ]
    },
    {
      'category': 'api security management',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Platform Console',
          route: '',
          icon: 'fa fa-globe'
        },
        {
          categoryName: 'Developer Experience',
          route: '/businessdetails',
          icon: 'fa fa-building-o'
        },
        {
          categoryName: 'API Gateway',
          route: '/usergroups',
          icon: 'fa fa-id-badge'
        },
        {
          categoryName: 'Fie Storage',
          route: '/themes',
          icon: 'fa fa-themeisle'
        },
        {
          categoryName: 'Databases',
          route: '/permissions',
          icon: 'fa fa-shield'
        }
      ]
    },
    {
      'category': 'development environments',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Platform Console',
          route: '',
          icon: 'fa fa-globe'
        },
        {
          categoryName: 'Developer Experience',
          route: '/businessdetails',
          icon: 'fa fa-building-o'
        },
        {
          categoryName: 'API Gateway',
          route: '/usergroups',
          icon: 'fa fa-id-badge'
        },
        {
          categoryName: 'Fie Storage',
          route: '/themes',
          icon: 'fa fa-themeisle'
        },
        {
          categoryName: 'Databases',
          route: '/permissions',
          icon: 'fa fa-shield'
        }
      ]
    },
    {
      'category': 'productivity tools',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Platform Console',
          route: '',
          icon: 'fa fa-globe'
        },
        {
          categoryName: 'Developer Experience',
          route: '/businessdetails',
          icon: 'fa fa-building-o'
        },
        {
          categoryName: 'API Gateway',
          route: '/usergroups',
          icon: 'fa fa-id-badge'
        },
        {
          categoryName: 'Fie Storage',
          route: '/themes',
          icon: 'fa fa-themeisle'
        },
        {
          categoryName: 'Databases',
          route: '/permissions',
          icon: 'fa fa-shield'
        }
      ]
    },
    {
      'category': 'settings',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          categoryName: 'Platform Console',
          route: '',
          icon: 'fa fa-globe'
        },
        {
          categoryName: 'Developer Experience',
          route: '/businessdetails',
          icon: 'fa fa-building-o'
        },
        {
          categoryName: 'API Gateway',
          route: '/usergroups',
          icon: 'fa fa-id-badge'
        },
        {
          categoryName: 'Fie Storage',
          route: '/themes',
          icon: 'fa fa-themeisle'
        },
        {
          categoryName: 'Databases',
          route: '/permissions',
          icon: 'fa fa-shield'
        }
      ]
    },
  ];
  settingsPayloadToInsert = {
    partner: '',
    account: '',
    email: '',
    phone_number: '',
    environments: [],
    is_enabled: true,
    subscriptions: {
      providers: [],
      platform_services: [],
      platform_service_categories: []
    },
    logo: '',
    brand_image: ''
  };
  loadingForTheFirstTime = true;
  loadingForTheFirstTimeCompleted = false;
  leftPanelLoading = false;
  progressMessage = '';
  partnerInfo = [
    {
      title: 'Email',
      value: localStorage.getItem('signInEmail'),
      icon: 'fa fa-envelope',
      showCopy: false
    },
    {
      title: 'Partner Short Code',
      value: '',
      icon: 'fa fa-user',
      showCopy: false
    },
    {
      title: 'Partner Key',
      value: localStorage.getItem('partnerKey'),
      icon: 'fa fa-key',
      showCopy: true
    },
    {
      title: 'API Key',
      value: '',
      icon: 'fa fa-key',
      showCopy: true
    }
  ];
  @Output() isDataInitialised = new EventEmitter<any>();
  applicationPermissionConfig: any;

  menus = [
    {
      validOn: 'admin',
      stickyMenus: [
        // {
        //   name: 'environments',
        //   displayName: 'Environments',
        //   tooltipText: 'Administration of environments, tools and infrastructure',
        //   hasSubMenu: true,
        //   submenus: [
        //     {
        //       categoryName: 'Admin',
        //       route: '/administrator',
        //       icon: 'fa fa-user'
        //     },
        //     {
        //       categoryName: 'Development',
        //       route: '/administrator',
        //       icon: 'fa fa-building'
        //     }
        //   ],
        //   displayType: 'block',
        //   icon: 'fa fa-cogs',
        // },
        // {
        //   name: 'platform experience',
        //   displayName: 'Platform Experience',
        //   tooltipText: 'Platfrom Experience',
        //   hasSubMenu: true,
        //   displayType: 'block',
        //   icon: 'fa fa-handshake',
        //   submenus: [
        //     {
        //       categoryName: 'Platform Console',
        //       route: '/platformconsole',
        //       icon: 'fa fa-tv'
        //     },
        //     {
        //       categoryName: 'Developer Experience',
        //       route: '/developerexperience',
        //       icon: 'fa fa-rocket'
        //     },
        //     {
        //       categoryName: 'API Gateway',
        //       route: '/apigateway',
        //       icon: 'fa fa-shield-alt'
        //     },
        //     {
        //       categoryName: 'File Storage',
        //       route: 'filestorage',
        //       icon: 'fa fa-folder'
        //     },
        //     {
        //       categoryName: 'Databases',
        //       route: 'databases',
        //       icon: 'fa fa-database'
        //     }
        //   ]
        // },
        {
          name: 'identity and access management',
          displayName: 'IAM',
          tooltipText: 'Identity and Access Management',
          hasSubMenu: true,
          displayType: 'block',
          icon: 'fa fa-user',
          submenus: [
            {
              categoryName: 'Platform Console',
              route: '',
              icon: 'fa fa-globe'
            },
            {
              categoryName: 'Developer Experience',
              route: '/businessdetails',
              icon: 'fa fa-building-o'
            },
            {
              categoryName: 'API Gateway',
              route: '/usergroups',
              icon: 'fa fa-id-badge'
            },
            {
              categoryName: 'File Storage',
              route: '/themes',
              icon: 'fa fa-themeisle'
            },
            {
              categoryName: 'Databases',
              route: '/permissions',
              icon: 'fa fa-shield'
            }
          ]
        },
        {
          name: 'api security management',
          displayName: 'Consumers',
          tooltipText: 'API Security Management',
          hasSubMenu: true,
          displayType: 'block',
          icon: 'fa fa-lock',
          submenus: [
            {
              categoryName: 'Platform Console',
              route: '',
              icon: 'fa fa-globe'
            },
            {
              categoryName: 'Developer Experience',
              route: '/businessdetails',
              icon: 'fa fa-building-o'
            },
            {
              categoryName: 'API Gateway',
              route: '/usergroups',
              icon: 'fa fa-id-badge'
            },
            {
              categoryName: 'Fie Storage',
              route: '/themes',
              icon: 'fa fa-themeisle'
            },
            {
              categoryName: 'Databases',
              route: '/permissions',
              icon: 'fa fa-shield'
            }
          ]
        },
        {
          name: 'development environments',
          displayName: 'DevEnv',
          tooltipText: 'Development Environment',
          hasSubMenu: true,
          displayType: 'block',
          icon: 'fa fa-tv',
          submenus: [
            {
              categoryName: 'Platform Console',
              route: '',
              icon: 'fa fa-globe'
            },
            {
              categoryName: 'Developer Experience',
              route: '/businessdetails',
              icon: 'fa fa-building-o'
            },
            {
              categoryName: 'API Gateway',
              route: '/usergroups',
              icon: 'fa fa-id-badge'
            },
            {
              categoryName: 'Fie Storage',
              route: '/themes',
              icon: 'fa fa-themeisle'
            },
            {
              categoryName: 'Databases',
              route: '/permissions',
              icon: 'fa fa-shield'
            }
          ]
        },
        {
          name: 'productivity tools',
          displayName: 'Tools',
          tooltipText: 'Productivity Tools',
          hasSubMenu: true,
          displayType: 'block',
          icon: 'fa fa-wrench',
          submenus: [
            {
              categoryName: 'Platform Console',
              route: '',
              icon: 'fa fa-globe'
            },
            {
              categoryName: 'Developer Experience',
              route: '/businessdetails',
              icon: 'fa fa-building-o'
            },
            {
              categoryName: 'API Gateway',
              route: '/usergroups',
              icon: 'fa fa-id-badge'
            },
            {
              categoryName: 'Fie Storage',
              route: '/themes',
              icon: 'fa fa-themeisle'
            },
            {
              categoryName: 'Databases',
              route: '/permissions',
              icon: 'fa fa-shield'
            }
          ]
        },
        {
          name: 'settings',
          displayName: 'Settings',
          tooltipText: 'Settings',
          hasSubMenu: true,
          displayType: 'block',
          icon: 'fa fa-cog',
          submenus: [
            {
              categoryName: 'Platform Console',
              route: '',
              icon: 'fa fa-globe'
            },
            {
              categoryName: 'Developer Experience',
              route: '/businessdetails',
              icon: 'fa fa-building-o'
            },
            {
              categoryName: 'API Gateway',
              route: '/usergroups',
              icon: 'fa fa-id-badge'
            },
            {
              categoryName: 'Fie Storage',
              route: '/themes',
              icon: 'fa fa-themeisle'
            },
            {
              categoryName: 'Databases',
              route: '/permissions',
              icon: 'fa fa-shield'
            }
          ]
        },
        // {
        //   name: 'partner settings',
        //   displayName: 'Partner Settings',
        //   tooltipText: 'Partner specific settings',
        //   hasSubMenu: true,
        //   displayType: 'block',
        //   icon: 'fa fa-cog',
        //   submenus: [
        //     {
        //       categoryName: 'Business Locations',
        //       route: '/businesslocations',
        //       icon: 'fa fa-globe'
        //     },
        //     {
        //       categoryName: 'Business Details',
        //       route: '/businessdetails',
        //       icon: 'fa fa-building-o'
        //     },
        //     {
        //       categoryName: 'Branding',
        //       route: '/usergroups',
        //       icon: 'fa fa-id-badge'
        //     },
        //     {
        //       categoryName: 'Themes',
        //       route: '/themes',
        //       icon: 'fa fa-themeisle'
        //     },
        //     {
        //       categoryName: 'Security',
        //       route: '/permissions',
        //       icon: 'fa fa-shield'
        //     },
        //     {
        //       categoryName: 'BOT',
        //       route: '/usergroups',
        //       icon: 'fa fa-commenting-o'
        //     },
        //     {
        //       categoryName: 'API Creators',
        //       route: '/users',
        //       icon: 'fa fa-plus'
        //     },
        //     {
        //       categoryName: 'API Transformers',
        //       route: '/users',
        //       icon: 'fa fa-exchange'
        //     },
        //     {
        //       categoryName: 'API Integrators',
        //       route: '/users',
        //       icon: 'fa fa-user'
        //     },
        //     {
        //       categoryName: 'API Management',
        //       route: '/apimanagement',
        //       icon: 'fa fa-cog'
        //     },
        //     {
        //       categoryName: 'Manage Email Configurations',
        //       route: '/email-settings',
        //       icon: 'fa fa-cog'
        //     },
        //     {
        //       categoryName: 'Idle Timeout Settings',
        //       route: '/idle-timeout',
        //       icon: 'fa fa-clock-o'
        //     }
        //   ]
        // },
        {
          name: 'billing',
          displayName: 'Billing',
          tooltipText: 'Billing',
          hasSubMenu: false,
          route: '/billing',
          displayType: 'block',
          icon: 'fa fa-usd',
        }
      ]

    },
    {
      validOn: 'environments',
      stickyMenus: [
        {
          name: 'creation',
          displayName: 'Create',
          tooltipText: 'Create APIs',
          hasSubMenu: true,
          displayType: 'block',
          icon: 'fa fa-plus',
          submenus: [
            {
              categoryName: 'Data as a Service',
              route: '/dataaccessapi',
              icon: 'fa fa-table'
            },
            {
              categoryName: 'Data as a Service (Advanced)',
              route: '/dataaccessapi-advanced',
              icon: 'fa fa-table'
            },
            {
              categoryName: 'Application Logic',
              route: '/businesslogic',
              icon: 'fa fa-link'
            },
            {
              categoryName: 'Workflows',
              route: '/workflow',
              icon: 'fa fa-sitemap'
            },
            {
              categoryName: 'Decisions',
              route: '/dmn',
              icon: 'fa fa-codepen'
            },
            {
              categoryName: 'SQL as a Service',
              route: '/querybuilder',
              icon: 'fa fa-database'
            },
            {
              categoryName: 'PLSQL as a Service',
              route: '/plsql',
              icon: 'fa fa-tasks'
            },
            {
              categoryName: 'API Joins',
              route: '/unified-query-builder',
              icon: 'fa fa-server'
            },
            {
              categoryName: 'API Collections',
              route: '/collections',
              icon: 'fa fa-object-group'
            },
            {
              categoryName: 'Test Suite as a Service',
              route: '/testsuite',
              icon: 'fa fa-check-circle-o'
            },
          ]
        },
        {
          name: 'connect',
          displayName: 'Integrate',
          tooltipText: 'Integrate APIs',
          hasSubMenu: true,
          displayType: 'block',
          icon: 'fa fa-anchor',
          submenus: [
            {
              categoryName: 'API Providers',
              route: '/providers',
              icon: 'fa fa-table'
            },
            {
              categoryName: 'API Provider Categories',
              route: '/provider-category',
              icon: 'fa fa-table'
            },
            {
              categoryName: 'Accelerators',
              route: '/accelerators',
              icon: 'send_time_extension',
              iconType: 'mat-icon'
            },
            {
              categoryName: 'Database Connectors',
              route: '/databases',
              icon: 'fa fa-database'
            },
            {
              categoryName: 'API Register',
              route: '/api-register',
              icon: 'fa fa-book'
            },
            {
              categoryName: 'Postman Collection',
              route: '/postman-collections',
              icon: 'fa fa-rocket'
            }
          ]
        },
        {
          name: 'transform',
          displayName: 'Transform',
          tooltipText: 'Transform APIs',
          hasSubMenu: true,
          displayType: 'block',
          icon: 'fa fa-random',
          submenus: [
            {
              categoryName: 'Design2API',
              route: '/application',
              icon: 'fa fa-table'
            },
            {
              categoryName: 'Data2API',
              route: '/datacatalog',
              icon: 'fa fa-table'
            },
            // {
            //     categoryName: 'Files to API',
            //     route: '/jsontoapi',
            //     icon: 'fa fa-table'
            // },
            {
              categoryName: 'COBOL2API',
              route: '/coboltoapi',
              icon: 'fa fa-table'
            },
            {
              categoryName: 'Data Transformation',
              route: '/transform',
              icon: 'fa fa-database'
            },
            // {
            //     categoryName: 'DataAPI to API',
            //     route: '/apitoapi',
            //     icon: 'fa fa-table'
            // }
          ]
        },
        // {
        //     name: 'register',
        //     displayName: 'Register',
        //     tooltipText: 'Register',
        //     hasSubMenu: true,
        //     displayType: 'block',
        //     icon: 'fa fa-book',
        //     submenu: [
        //         {
        //             name: 'API Register',
        //             route: '/api-register',
        //             icon: 'fa fa-book'
        //         },
        //         {
        //             name: 'Postman Collection',
        //             route: '/postman-collections',
        //             icon: 'fa fa-rocket'
        //         },
        //     ]
        // },
        // {
        //     name: 'reference',
        //     displayName: 'Reference',
        //     tooltipText: 'API Reference',
        //     hasSubMenu: false,
        //     route: '/docs',
        //     displayType: 'block',
        //     icon: 'fa fa-file-code-o',
        // },
        {
          name: 'test',
          displayName: 'Test',
          tooltipText: 'Test',
          hasSubMenu: true,
          route: '/devex',
          displayType: 'block',
          icon: 'fa fa-rocket',
          submenus: [
            {
              name: 'Devex',
              route: '/devex',
              icon: 'fa fa-book'
            }, {
              name: 'Test Suite',
              route: '/testsuite',
              icon: 'fa fa-check-circle-o'
            }, {
              name: 'Test-suite Results',
              route: '/test-results',
              icon: 'fa fa-graduation-cap'
            },
            {
              name: 'Register from Postman Collection',
              route: '/provider-category',
              icon: 'fa fa-rocket'
            },
          ]
        },
        {
          name: 'manage',
          displayName: 'Manage',
          tooltipText: 'Manage your APIs',
          hasSubMenu: true,
          displayType: 'list',
          icon: 'fa fa-tasks',
          submenus: [
            {
              name: 'Data Access API'
            },
            {
              name: 'Business Logic API'
            },
            {
              name: 'Open API'
            },
            {
              name: 'COBOL to API'
            },
            {
              name: 'Database to API'
            },
            {
              name: 'Query Builder'
            },
            {
              name: 'API Query Builder'
            },
            {
              name: 'PLSQL Builder'
            },
            {
              name: 'Email Template Builder'
            },
            {
              name: 'Workflow Builder'
            },
            {
              name: 'Decision Builder'
            },
            {
              name: 'Documentor'
            },
            {
              name: 'API Collection'
            },
            {
              name: 'UX Builder'
            }
          ]
        },
        {
          name: 'tools',
          displayName: 'Tools',
          tooltipText: 'Tools',
          hasSubMenu: true,
          displayType: 'block',
          icon: 'fa fa-connectdevelop',
          submenu: [
            {
              name: 'API tester',
              route: '/devex',
              icon: 'fa fa-table'
            },
            // {
            //     name: 'API Documentor',
            //     route: '/devex',
            //     icon: 'fa fa-table'
            // },
            // {
            //     name: 'Content Development',
            //     route: '/devex',
            //     icon: 'fa fa-table'
            // },
            {
              name: 'API Registrar',
              route: '/devex',
              icon: 'fa fa-table'
            },
            {
              name: 'Scheduler',
              route: '/scheduler',
              icon: 'fa fa-calendar'
            }
          ]
        },
        // {
        //     name: 'samples',
        //     displayName: 'Samples',
        //     tooltipText: 'Samples',
        //     hasSubMenu: false,
        //     route: '/samples',
        //     displayType: 'block',
        //     icon: 'fa fa-free-code-camp',
        // },
        // {
        //     name: 'learn',
        //     displayName: 'Learn',
        //     tooltipText: 'Learn',
        //     hasSubMenu: true,
        //     displayType: 'block',
        //     icon: 'fa fa-graduation-cap',
        //     submenu: []
        // },
        // {
        //     name: 'settings',
        //     displayName: 'Settings',
        //     tooltipText: 'Settings',
        //     hasSubMenu: true,
        //     displayType: 'block',
        //     icon: 'fa fa-cog',
        //     submenu: []
        // },
        // {
        //     name: 'journey',
        //     displayName: 'Journey',
        //     tooltipText: 'Journey Analytics',
        //     hasSubMenu: false,
        //     route: '/journey',
        //     displayType: 'block',
        //     icon: 'fa fa-line-chart',
        // },
        // {
        //     name: 'partner-info',
        //     displayName: 'Partner Info',
        //     tooltipText: 'Partner Info',
        //     hasSubMenu: true,
        //     displayType: 'block',
        //     icon: 'fa fa-info',
        //     submenu: []
        // },
      ]
    }
  ];
  properties = [];
  consumerId: any;
  OAuthClientApps: any;

  apiHistory: any;
  isHistoryAvailable = false;

  apiKeyData: any;
  apiKey: any;
  apiKeys: any;
  entities: any;
  partnerEntities: any;
  partnerEntityTypes = [];
  partnerCategories: any;
  progress = 0;
  incr = 4;
  executorLoadingInLeftPanel = false;
  allExecutorsButDaaS = [];
  leftpanelData: any;

  partnerExecutors: any;
  apiExecutors: any;
  countOfApiExecutors = 0;
  businessLogicExecutors: any;
  executors: any;
  countOfBusinessLogicApis = 0;
  thirdPartyApiExecutors: any;
  countOfThirdPartyApis = 0;
  sqlQueryExecutors: any;
  countOfSqlQueryApis = 0;
  dataTransformationExecutors: any;
  countOfDataTransformationApis = 0;
  unifiedQueryExecutors: any;
  countOfUnifiedQueryApis = 0;
  testSuiteExecutors: any;
  countOfTestSuiteApis = 0;
  workFlowExecutors: any;
  countOfWorkflowApis = 0;
  dmnExecutors: any;
  countOfDmnApis = 0;
  b2bExecutors: any;
  myProviderExecutors: any;
  plsqlExecutors: any;
  countOfPlSqlApis = 0;

  applicationData: any;
  countOfApplications = 0;

  languages: any;

  databases: any;
  datatypes: any;
  apiGateways: any;

  countPartnerEntities: any;
  categoriesEntitiesForPartner: any;
  databaseObjectTypes: any;
  providerObjects = {};
  maxCount: any;
  authorizationTypes: any;
  platformServiceProviders: any;
  partnerServiceProviders: any;
  selectedAPIGateway: any;
  selectedAPIGatewayName: string;

  defaultGatewaySettings = [
    {
      'name': 'key-auth',
      'isConfigured': false,
      'img': '/assets/img/key-auth.png',
      'description': 'Configure KeyAuth service..',
      'tagline': 'Add Key Authentication (also referred to as an API key) to your APIs. Consumers then add their key either in a querystring parameter or a header to authenticate their requests.',
      'config': [
        {
          'displayName': 'Key Names',
          'parameter': 'key_names',
          'type': 'array_string',
          'value': 'apikey',
          'isRequired': true,
          'description': 'Describes an array of parameter names where the plugin will look for a key. The client must send the authentication key in one of those key names, and the plugin will try to read the credential from a header, request body, or query string parameter with the same name.\n' +
              'Note: The key names may only contain [a-z], [A-Z], [0-9], [_] underscore, and [-] hyphen'
        },
        {
          'displayName': 'Key In Body',
          'parameter': 'key_in_body',
          'type': 'boolean',
          'value': false,
          'isRequired': false,
          'description': 'If enabled, the plugin reads the request body (if said request has one and its MIME type is supported) and tries to find the key in it. Supported MIME types: application/www-form-urlencoded, application/json, and multipart/form-data'
        },
        {
          'displayName': 'Hide Credentials',
          'parameter': 'hide_credentials',
          'type': 'boolean',
          'value': false,
          'isRequired': false,
          'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e., the header, query string, or request body containing the key) before proxying it'
        },
        {
          'displayName': 'Run On Preflight',
          'parameter': 'run_on_preflight',
          'type': 'boolean',
          'value': true,
          'isRequired': false,
          'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests are always allowed'
        },
        {
          'displayName': 'Key In Header',
          'parameter': 'key_in_header',
          'type': 'boolean',
          'value': true,
          'isRequired': false,
          'description': 'If enabled (default), the plugin reads the request header and tries to find the key in it'
        },
        {
          'displayName': 'Key In Query',
          'parameter': 'key_in_query',
          'type': 'boolean',
          'value': true,
          'isRequired': false,
          'description': 'If enabled (default), the plugin reads the query parameter in the request and tries to find the key in it'
        },
      ],
      'id': 9,
      'itemName': 'key-auth'
    },
    {
      'name': 'cors',
      'isConfigured': false,
      'img': 'assets/img/cors.png',
      'description': 'Configure CORS service.',
      'tagline': 'Allow developers to make requests from the browser',
      'config': [
        {
          'displayName': 'Origins',
          'parameter': 'origins',
          'type': 'array_string',
          'value': '*',
          'isRequired': false,
          'description': 'List of allowed domains for the Access-Control-Allow-Origin header. If you want to allow all origins, add * as a single value to this configuration field. The accepted values can either be flat strings or PCRE regexes'
        },
        {
          'displayName': 'Headers',
          'parameter': 'headers',
          'type': 'array_string',
          'value': null,
          'isRequired': false,
          'description': 'Tip: Comma separated values for the Access-Control-Allow-Headers header, expects a comma delimited string (e.g. Origin, Authorization).'
        },
        {
          'displayName': 'Exposed Headers',
          'parameter': 'exposed_headers',
          'type': 'array_string',
          'value': null,
          'isRequired': false,
          'description': 'Tip: Comma separated values for the Access-Control-Expose-Headers header, expects a comma delimited string (e.g. Origin, Authorization). If not specified, no custom headers are exposed.'
        },
        {
          'displayName': 'Methods',
          'parameter': 'methods',
          'type': 'array_string',
          'value': null,
          'isRequired': false,
          'description': 'Value for the Access-Control-Allow-Methods header. Available options include GET, HEAD, PUT, PATCH, POST, DELETE, OPTIONS, TRACE, CONNECT. By default, all options are allowed'
        },
        {
          'displayName': 'Max Age',
          'parameter': 'max_age',
          'type': 'number',
          'value': 300,
          'isRequired': false,
          'description': 'Indicates how long the results of the preflight request can be cached, in seconds'
        },
        {
          'displayName': 'Credentials',
          'parameter': 'credentials',
          'type': 'boolean',
          'value': false,
          'isRequired': true,
          'description': 'Flag to determine whether the Access-Control-Allow-Credentials header should be sent with true as the value'
        },
        {
          'displayName': 'Preflight Continue',
          'parameter': 'preflight_continue',
          'type': 'boolean',
          'value': false,
          'isRequired': true,
          'description': 'A boolean value that instructs the plugin to proxy the OPTIONS preflight request to the Upstream service'
        }
      ],
      'id': 11,
      'itemName': 'cors'
    },
    {
      'name': 'ip-restriction',
      'isConfigured': false,
      'img': 'assets/img/ip-restriction.png',
      'description': 'Configure IP Restriction service.',
      'tagline': 'Whitelist or blacklist IPs that can make requests',
      'config': [
        {
          'displayName': 'Allow',
          'parameter': 'allow',
          'type': 'array_string',
          'value': '127.0.0.1',
          'description': 'Tip: Comma separated list of IPs or CIDR ranges to whitelist. At least one between whitelist or blacklist must be specified.'
        },
        {
          'displayName': 'Deny',
          'parameter': 'deny',
          'type': 'array_string',
          'value': null,
          'description': 'Tip: Comma separated list of IPs or CIDR ranges to blacklist. At least one between whitelist or blacklist must be specified.'
        }
      ],
      'id': 12,
      'itemName': 'ip-restriction'
    },
    {
      'name': 'rate-limiting',
      'isConfigured': false,
      'img': '/assets/img/rate-limiting.png',
      'description': 'Configure Rate limiting service.',
      'tagline': ' Rate limit how many HTTP requests a developer can make in a given period of seconds, minutes, hours, days, months or years. If the API has no authentication layer, the Client IP address will be used, otherwise the Consumer will be used if an authentication plugin has been configured.',
      'config': [
        {
          'displayName': 'Second',
          'parameter': 'second',
          'type': 'number',
          'value': null,
          'isRequired': false,
          'description': 'The number of HTTP requests that can be made per second'
        },
        {
          'displayName': 'Minute',
          'parameter': 'minute',
          'type': 'number',
          'value': 5,
          'isRequired': false,
          'description': 'The number of HTTP requests that can be made per minute'
        },
        {
          'displayName': 'Hour',
          'parameter': 'hour',
          'type': 'number',
          'value': null,
          'isRequired': false,
          'description': 'The number of HTTP requests that can be made per hour'
        },
        {
          'displayName': 'Day',
          'parameter': 'day',
          'type': 'number',
          'value': null,
          'isRequired': false,
          'description': 'The number of HTTP requests that can be made per day'
        },
        {
          'displayName': 'Month',
          'parameter': 'month',
          'type': 'number',
          'value': null,
          'isRequired': false,
          'description': 'The number of HTTP requests that can be made per month'
        },
        {
          'displayName': 'Year',
          'parameter': 'year',
          'type': 'number',
          'value': null,
          'isRequired': false,
          'description': 'The number of HTTP requests that can be made per year'
        },
        {
          'displayName': 'Limit By',
          'parameter': 'limit_by',
          'type': 'string',
          'value': 'consumer',
          'isRequired': false,
          'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip, service, header, path. If the value for the entity chosen to aggregate the limit cannot be determined, the system will always fallback to ip. If value service is chosen, the service_id configuration must be provided. If value header is chosen, the header_name configuration must be provided. If value path is chosen, the path configuration must be provided'
        },
        {
          'displayName': 'Policy',
          'parameter': 'policy',
          'type': 'string',
          'value': 'local',
          'isRequired': false,
          'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n' +
              '\n' +
              'In Konnect Cloud, the default policy is redis'
        },
        {
          'displayName': 'Fault Tolerant',
          'parameter': 'fault_tolerant',
          'type': 'boolean',
          'value': true,
          'isRequired': false,
          'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
        },
        {
          'displayName': 'Hide Client Headers',
          'parameter': 'hide_client_headers',
          'type': 'boolean',
          'value': false,
          'isRequired': false,
          'description': 'Optionally hide informative response headers'
        },
        {
          'displayName': 'Redis Host',
          'parameter': 'redis_host',
          'type': 'string',
          'value': 'localhost',
          'isRequired': false,
          'description': 'When using the redis policy, this property specifies the address to the Redis server'
        },
        {
          'displayName': 'Redis Password',
          'parameter': 'redis_password',
          'type': 'string',
          'value': '',
          'isRequired': false,
          'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
        },
        {
          'displayName': 'Redis Port',
          'parameter': 'redis_port',
          'type': 'number',
          'value': 6379,
          'isRequired': false,
          'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379'
        },
        {
          'displayName': 'Redis Timeout',
          'parameter': 'redis_timeout',
          'type': 'number',
          'value': 2000,
          'isRequired': false,
          'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
        },
        {
          'displayName': 'Redis Database',
          'parameter': 'redis_database',
          'type': 'number',
          'value': 0,
          'isRequired': false,
          'description': 'When using the redis policy, this property specifies the Redis database to use'
        },
      ],
      'id': 18,
      'itemName': 'rate-limiting'
    }
  ];
  defaultDatabaseConfiguration = {
    database_name: 'default',
    database_type: 'mongodb',
    region: '',
    database_attributes: {},
    is_default: true,
    audit_logs: [
      {
        action: 'CREATE',
        by: localStorage.getItem('signInEmail'),
        at: 1601280370723
      }
    ]
  };
  selection: any;
  settingsDataWithoutDBRef: any;
  registeredConnectors: any;
  queryBuilderAttributes: any;

  deleteAccess = false;
  pkey = localStorage.getItem('partnerKey');
  searchText1 = {
    'executor_name': ''
  };
  workflowapis: any;
  sqlqueryapis: any;
  commons = [];
  editAccess = false;
  businessTemplates = [];
  thirdpartyapis: any;
  settings = [
    {
      'category': 'Partner Settings',
      'expand': true,
      'route': null,
      'subcategory': [
        {
          'categoryName': 'Business Details',
          'route': '/businessdetails'
        },
        {
          'categoryName': 'Branding',
          'route': '/branding'
        },
        {
          'categoryName': 'Accounts',
          'route': '/accounts'
        },
        // {
        //     'categoryName': 'API Keys',
        //     'route': '/api-key'
        // },
        {
          'categoryName': 'Business Locations',
          'route': '/businesslocations'
        },
        // {
        //     'categoryName': 'Dashboard',
        //     'route': '/dashboard'
        // },
        {
          'categoryName': 'Databases',
          'route': '/databases'
        },
        // {
        //     'categoryName': 'Metrics',
        //     'route': '/metrics-settings'
        // },
        {
          'categoryName': 'IP Restrictions',
          'route': '/ipconfig'
        },
        {
          'categoryName': 'Identity Manager',
          'route': '/identitymanager'
        },
        {
          'categoryName': 'Credits',
          'route': '/credits'
        },
        {
          'categoryName': 'Coupon Management',
          'route': '/coupon-management-settings'
        },
        // {
        //     'categoryName': 'Encryption',
        //     'route': '/encryption-settings'
        // },
        {
          'categoryName': 'Email',
          'route': '/email-settings'
        },
        {
          'categoryName': 'Document Viewer',
          'route': '/docs'
        },
        {
          'categoryName': 'Document Editor',
          'route': '/docseditor'
        },
        // {
        //     'categoryName': 'Campaign',
        //     'route': '/campaign-settings'
        // },
        // {
        //     'categoryName': 'Audience',
        //     'route': '/audience-settings'
        // },
        // {
        //     'categoryName': 'Compliances',
        //     'route': '/compliance-settings'
        // },
        // {
        //     'categoryName': 'Roles',
        //     'route': '/roles-settings'
        // },
        // {
        //     'categoryName': 'Users',
        //     'route': '/users-settings'
        // },
        // {
        //     'categoryName': 'Permission',
        //     'route': '/permission-settings'
        // },
        // {
        //     'categoryName': 'User Groups',
        //     'route': '/user-groups-settings'
        // },
        // {
        //     'categoryName': 'Permission Groups',
        //     'route': '/permission-group-settings'
        // },
        // {
        //     'categoryName': 'Source Control Management',
        //     'route': '/source-control-management-settings'
        // },
        // {
        //     'categoryName': 'Connectors',
        //     'route': '/connectors-settings'
        // }
        // {
        //     'categoryName': 'API Integrations',
        //     'route': '/integrations'
        // },
        {
          'categoryName': 'API Categories',
          'route': '/categories'
        },
        {
          'categoryName': 'Service Categories',
          'route': '/provider-category'
        },
        {
          'categoryName': 'Service Providers',
          'route': '/providers'
        }
      ]
    },
//         {
//     'category': 'Platform Settings',
//     'expand': false,
//     'route': null,
//     'subcategory': [
//         {
//             'categoryName': 'Themes',
//             'route': '/themes-settings'
//         },
//         {
//             'categoryName': 'Subscription',
//             'route': '/subscription-settings'
//         },
//         {
//             'categoryName': 'Billing',
//             'route': '/billing-settings'
//         },
//         {
//             'categoryName': 'Services',
//             'route': '/services-settings'
//         },
//         {
//             'categoryName': 'Security',
//             'route': '/security-settings'
//         },
//         {
//             'categoryName': 'BOT',
//             'route': '/bot-settings'
//         },
//         {
//             'categoryName': 'Gateway Rate Limiting',
//             'route': '/gr-rate-limiting-settings'
//         },
//         {
//             'categoryName': 'Gateway CORS',
//             'route': '/gt-cors-settings'
//         },
//         {
//             'categoryName': 'Gateway IP Restrictions',
//             'route': '/gt-ip-settings'
//         },
//         {
//             'categoryName': 'Code Generators',
//             'route': '/code-gen-settings'
//         },
//         {
//             'categoryName': 'Integrators',
//             'route': '/integrator-settings'
//         },
//         {
//             'categoryName': 'Service Providers',
//             'route': '/service-providers-settings'
//         },
//         {
//             'categoryName': 'Transformation - Database',
//             'route': '/transformation-database-settings'
//         },
//         {
//             'categoryName': 'Transformation - COBOL',
//             'route': '/transformation-cobol-settings'
//         },
//         {
//             'categoryName': 'Transformation - API',
//             'route': '/transformation-api-settings'
//         },
//         {
//             'categoryName': 'DevEx',
//             'route': '/devex-settings'
//         },
//         {
//             'categoryName': 'Integration Languages',
//             'route': '/integration-languages-settings'
//         },
//         {
//             'categoryName': 'API Registrar',
//             'route': '/api-registrar-settings'
//         },
//     ]
// },
    {
      'category': 'Infrastructure Settings',
      'expand': false,
      'route': null,
      'subcategory': [
        // {
        //     'categoryName': 'Cloud Platforms',
        //     'route': '/cloud-platform-settings'
        // },
        {
          'categoryName': 'Environment',
          'route': '/environment-settings'
        },
        // {
        //     'categoryName': 'API Gateway Management',
        //     'route': '/api-gateway-settings'
        // }
        // {
        //     'categoryName': 'Databases',
        //     'route': '/database-inf-settings'
        // },
        {
          'categoryName': 'Secrets Managers',
          'route': '/logging-settings'
        }
        // {
        //     'categoryName': 'File System',
        //     'route': '/file-settings'
        // },
        // {
        //     'categoryName': 'Identity Management',
        //     'route': '/identity-settings'
        // },
        // {
        //     'categoryName': 'Traffic',
        //     'route': '/traffic-settings'
        // }
      ]
    }
  ];
  panelOpenState = true;
  DisplayApiByCategory = true;
  businessLogic = [];
  sql = [];
  workflow = [];
  decision = [];
  term: any;

  showFiller = true;
  backGroundColor = '#F2F2F2';

  selectedEnvironment: any = {};
  environment: any;
  adminMenu: Menu[] = [
    {
      name: 'Platform Experience',
      display_name: 'Platform',
      iconClass: 'fa fa-handshake-o',
      active: false,
      toolTip: 'Platform Experience',
      route: null,
      submenu: [
        {name: 'Platform Console', key: 'Platform Console', icon: 'fa fa-desktop', toolTip: 'Platform Console', route: '/platform-console', submenu: null},
        {name: 'Developer Experience', key: 'Developer Experience', icon: 'fa fa-rocket', toolTip: 'Developer Experience', route: '/dev-ex', submenu: null},
        {name: 'API Gateway', key: 'API Gateway Manager', icon: 'fa fa-shield', toolTip: 'API Gateway', route: '/api-gateway-settings', submenu: null},
        {name: 'File Storage', key: 'Storage', icon: 'fa fa-folder', toolTip: 'File Storage', route: '/file-storage', submenu: null},
        {name: 'Databases', key: 'Databases', icon: 'fa fa-database', toolTip: 'Databases', route: '/data-bases', submenu: null}
      ]
    },
    {
      display_name: 'IAM',
      name: 'Identity and Access Management',
      iconClass: 'fa fa-key',
      active: false,
      toolTip: 'Identity and Access Management',
      route: null,
      submenu: [
        {name: 'Users', key: 'Users', icon: 'fa fa-user', toolTip: 'Users', route: '/users', submenu: null},
        {name: 'User Groups', key: 'UserGroups', icon: 'fa fa-users', toolTip: 'User Groups', route: '/user-groups', submenu: null},
        {name: 'Roles', key: 'Roles', icon: 'fa fa-universal-access', toolTip: 'Roles', route: '/roles', submenu: null},
        {name: 'Secrets Manager', key: 'Secrets Manager', icon: 'fa fa-user-secret', toolTip: 'Secrets Manager', route: '/secrets-manager', submenu: null}
      ]
    },
    {
      display_name: 'Consumers',
      name: 'API Security Management',
      iconClass: 'fa fa-lock',
      active: false,
      toolTip: 'API Security Management',
      route: null,
      submenu: [
        {name: 'Authorization Types', key: 'AuthorizationTypes', icon: 'fa fa-key', toolTip: 'Authorization Types', route: '/admin-auth-types', submenu: null},
        {name: 'Consumers', key: 'Consumers', icon: 'fa fa-user-circle', toolTip: 'Consumers', route: '/consumers', submenu: null},
        {name: 'Gateway Settings', key: 'GatewaySettings', icon: 'fa fa-shield', toolTip: 'Gateway Settings', route: '/gateway-settings', submenu: null}
      ]
    },
    {
      name: 'Development Environments',
      display_name: 'DevEnv',
      iconClass: 'fa fa-laptop',
      active: false,
      toolTip: 'Development Environments',
      route: null,
      submenu: [
        {name: 'Environments', key: 'Environments', icon: 'fa fa-laptop', toolTip: 'Environments', route: '/dev-environments', submenu: null}
      ]
    },
    {
      display_name: 'Tools',
      name: 'Productivity Tools',
      iconClass: 'fa fa-wrench',
      active: false,
      toolTip: 'Productivity Tools',
      route: null,
      submenu: [
        {name: 'Mail Servers', key: 'EmailConfigurations', icon: 'fa fa-envelope', toolTip: 'Mail Servers', route: '/email-setting', submenu: null},
        {name: 'S3 Connectors', key: 'S3 Bucket Connectors', icon: 'fa fa-file-archive-o', toolTip: 'S3 Connectors', route: '/s3-connectors', submenu: null}
      ]
    },
    {
      display_name: 'Settings',
      name: 'General',
      iconClass: 'fa fa-cog',
      active: false,
      toolTip: 'Settings',
      route: null,
      submenu: [
        {name: 'Partner Settings', key: 'PartnerSettings', icon: 'fa fa-cogs', toolTip: 'Partner Settings', route: '', submenu: [
            {name: 'Business Locations', key: 'businessLocations', icon: 'fa fa-globe', toolTip: 'Business Locations', route: '/businesslocations'},
            {name: 'Business Details', key: 'businessDetails', icon: 'fa fa-building-o', toolTip: 'Business Details', route: 'businessdetails'},
            {name: 'Branding', key: 'branding', icon: 'fa fa-id-badge', toolTip: 'Branding', route: 'branding'},
          ]},
        {name: 'Idle Timeout', key: 'IdleTimeOut', icon: 'fa fa-clock-o', toolTip: 'Idle Timeout', route: '/idletimeout', submenu: null}
      ]
    },
    {display_name: 'Billing', name: 'Billing', iconClass: 'fa fa-usd', active: false, toolTip: 'Billing', route: '/billing', submenu: null}
  ];
  menuPanel = {};
  menu: any;
  selectedEnvironmentIndex: number;
  selectedEnvironmentData: any;
  menuItems: any;

  constructor(
      public appComponent: AppComponent,
      private location: Location,
      private confPost: ConfService,
      private _service: ConnecttocrudService,
      private kong: KongService,
      private snackBar: MatSnackBar,
      public accountInfoService: AccountInfoService,
      private leftPanelDataListener: ListenerService,
      private dialog: MatDialog,
      private authService: AuthService,
      private router: Router,
      private adminEnvironmentHandler: AdminEnvironmentHandlerService
  ) { }

  getCurrentSession() {
    return new Promise((resolve, reject) => {
      this.confPost.getData('services',
          'services',
          'v1',
          'auditLogs',
          'sessionId=' + localStorage.getItem('sessionID')).subscribe(response => {
        if (response && response[0] && response[0] !== null && response[0] !== undefined) {
          this.currentSession = response[0];
          this.actionsOfCurrentSession = this.currentSession['actions'];
          resolve('success');
        }
      }, error => {
        this.openSnackBar('Error in retrieving current session', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        resolve('failed');
      });
    });
  }

  async getDefaultGatewayURL() {
    if (this.defaultGatewayURL && this.defaultGatewayURL !== '') {
      return this.defaultGatewayURL.toString();
    } else {

      this.defaultGatewayURL = localStorage.getItem('partner') + '.gateway.apiplatform.io';

      if (!this.settingsData) {
        await this.getSettingsData(localStorage.getItem('partner'), localStorage.getItem('account'), false);
      }
      if (this.settingsData) {
        if (this.settingsData.hasOwnProperty('body')) {
          this.settingsData = this.settingsData['body'][0];
        }
        const currentEnvironment = this.settingsData.environments.filter((env) => env['name'] === localStorage.getItem('partner'));
        if (currentEnvironment && currentEnvironment.length > 0) {
          const apigatewayService = currentEnvironment[0]['services'].filter((service) => service['type'] === 'apigateway');
          if (apigatewayService && apigatewayService.length > 0) {
            const defaultGateway = apigatewayService[0]['configurations'].filter((config) => config['is_default'] === true);
            if (defaultGateway && defaultGateway.length > 0) {
              this.defaultGatewayURL = defaultGateway[0]['url'][0];
            }
          }
        }
      }
      return this.defaultGatewayURL.toString();
    }
  }

  getSettingsData(partner, account, dbref) {
    return new Promise((resolve, reject) => {
      this.confPost.getSettingsV2CRUD(partner, account, dbref).subscribe(response => {
        if (response && response['body'] && response['body'][0]) {
          this.settingsData = response['body'][0];
          resolve('success');
        } else {
          reject('failed');
        }
      }, error => {
        reject(error);
      });
    });
  }

  getEnvironments() {
    return new Promise(((resolve, reject) => {
      this.availableEnvironmentsToSwitch = [];
      if (localStorage.getItem('partner') && localStorage.getItem('account')) {
        const partnerTemp = localStorage.getItem('partner').split('-');
        const accountTemp = localStorage.getItem('account').split('-');
        let partnerShortCode: string;
        let partnerAccount: string;
        if (partnerTemp.length > 1) {
          partnerShortCode = partnerTemp[partnerTemp.length - 1];
        } else {
          partnerShortCode = partnerTemp[0];
        }
        if (accountTemp.length > 1) {
          partnerAccount = accountTemp[accountTemp.length - 1];
        } else {
          partnerAccount = accountTemp[0];
        }
        this.confPost.getSettingsV2CRUD('admin-' + partnerShortCode, 'admin-' + partnerAccount, false).subscribe(response => {
          if (response && response['body'] && response['body'][0]) {
            const environments = response['body'][0]['environments'];
            this.environments = environments;

            if (environments && environments.length > 1) {
              environments.forEach(env => {
                const subMenuPayload = {};
                if (env && env !== undefined && env !== null) {
                  if (env['display_name'] &&
                      env['display_name'] !== null &&
                      env['display_name'] !== undefined &&
                      env['display_name'] !== '') {
                    subMenuPayload['categoryName'] = env['display_name'];
                  } else {
                    subMenuPayload['categoryName'] = env['type'];
                  }
                  switch (env['type']) {
                    case 'admin':
                      subMenuPayload['icon'] = 'fa fa-cog';
                      break;
                    case 'prod':
                      subMenuPayload['icon'] = 'fa fa-users';
                      break;
                    case 'dev':
                      subMenuPayload['icon'] = 'fa fa-users';
                      break;
                    case 'staging':
                      subMenuPayload['icon'] = 'fa fa-users';
                      break;
                    case 'qa':
                      subMenuPayload['icon'] = 'fa fa-users';
                      break;
                    default:
                      subMenuPayload['icon'] = 'fa fa-users';
                      break;
                  }
                  subMenuPayload['envName'] = env['type'];
                  subMenuPayload['environmentName'] = env['name'];
                  subMenuPayload['email'] = localStorage.getItem('signInEmail');
                  if (env['name'] !== localStorage.getItem('partner')) {
                    this.availableEnvironmentsToSwitch.push(subMenuPayload);
                  }
                }
              });
            }
          }
          resolve('Success');
        });

      } else {
        resolve('failed');
      }
    }));

  }

  setEnvironmentData() {
    const environmentData = this.masterData.find(item => item.category === 'environments');
    const environmentSubCategories: any = [];
    if ( this.environments) {
      for (const category of this.environments) {
        environmentSubCategories.push({
          categoryName: category.display_name,
          route: '/administration/' + category.name,
          hasPermission: true,
          icon: 'fa fa-user'
        });
      }
      const objectIndex = this.masterData.findIndex(item => item.category === 'environments');
      this.masterData[objectIndex].subcategory = environmentSubCategories;
    }

  }

  async setEnvironmentsToSettingsPayloadToInsert() {
    this.settingsPayloadToInsert.environments = [
      {
        name: '',
        type: '',
        cloud: [
          {
            type: 'aws',
            region: 'US-East (N.Virginia)',
            is_default: true,
            regions: [
              'US-East (N.Virginia)'
            ],
            audit_logs: [
              {
                action: 'CREATE',
                by: localStorage.getItem('signInEmail'),
                at: Date.now()
              }
            ]
          }
        ],
        display_name: '',
        is_validation_complete: false,
        is_creation_complete: true,
        services: [
          {
            name: 'Secrets Manager',
            type: 'secretsmanager',
            configurations: [
              {
                name: 'Default',
                providerName: 'apiplatform.io',
                image: './assets/img/partnerOnboarding/api.png',
                description: 'apiplatform\'s encryption mechanism',
                owner: 'apiplatform.io',
                is_default: true,
                audit_logs: [
                  {
                    action: 'CREATE',
                    by: localStorage.getItem('signInEmail'),
                    at: Date.now()
                  }
                ]
              }
            ]
          },
          {
            name: 'Databases',
            type: 'databases',
            configurations: []
          },
          {
            configurations: [
              {
                name: 'Platform Console',
                url: localStorage.getItem('partner') + '.apiplatform.io',
                audit_logs: [
                  {
                    action: 'CREATE',
                    by: localStorage.getItem('signInEmail'),
                    at: Date.now()
                  }
                ],
                status: true,
                verification_status: 'created',
                env_creation_status_after_verification: 'success',
                is_default: true,
                primary_region: 'US-East (N.Virginia)',
                cloud: 'aws',
                regions: [
                  'US-East (N.Virginia)'
                ]
              }
            ],
            name: 'Platform Console',
            type: 'dashboard'
          },
          {
            configurations: [
              {
                name: 'Developer Experience',
                url: localStorage.getItem('partner') + '.devex.apiplatform.io',
                audit_logs: [
                  {
                    action: 'CREATE',
                    by: localStorage.getItem('signInEmail'),
                    at: Date.now()
                  }
                ],
                status: true,
                verification_status: 'created',
                env_creation_status_after_verification: 'success',
                is_default: true,
                primary_region: 'US-East (N.Virginia)',
                cloud: 'aws',
                regions: [
                  'US-East (N.Virginia)'
                ]
              }
            ],
            name: 'Developer Experience',
            type: 'devex'
          },
          {
            configurations: [
              {
                name: 'API Gateway Manager',
                provider: 'apiplatform.io',
                gateway_configurations: {},
                url: await this.getDefaultGatewayURL(),
                audit_logs: [
                  {
                    action: 'CREATE',
                    by: localStorage.getItem('signInEmail'),
                    at: Date.now()
                  }
                ],
                status: true,
                verification_status: 'created',
                env_creation_status_after_verification: 'success',
                is_default: true,
                primary_region: 'US-East (N.Virginia)',
                cloud: 'aws',
                regions: [
                  'US-East (N.Virginia)'
                ]
              }
            ],
            name: 'API Gateway Manager',
            type: 'apigateway'
          },
          {
            configurations: [
              {
                name: 'Storage',
                provider: 'apiplatform.io',
                url: 'https://s3.amazonaws.com/' + localStorage.getItem('partner') + '.apiplatform.io',
                audit_logs: [
                  {
                    action: 'CREATE',
                    by: localStorage.getItem('signInEmail'),
                    at: Date.now()
                  }
                ],
                status: true,
                verification_status: 'created',
                env_creation_status_after_verification: 'success',
                is_default: true,
                primary_region: 'US-East (N.Virginia)',
                cloud: 'aws',
                regions: [
                  'US-East (N.Virginia)'
                ]
              }
            ],
            name: 'Storage',
            type: 'storage'
          },
          {
            configurations: [
              {
                name: 'S3 Bucket Connectors',
                audit_logs: [
                  {
                    action: 'CREATE',
                    by: localStorage.getItem('signInEmail'),
                    at: Date.now()
                  }
                ],
                is_default: true,
                provider: 'apiplatform.io',
                bucketName: localStorage.getItem('partner') + '.apiplatform.io',
                defaultBucket: true
              }
            ],
            name: 'S3 Bucket Connectors',
            type: 's3BucketConnectors'
          }
        ],
        is_enabled: false
      }
    ];
  }

  getApplicationPermissionGroupConfig() {
    return new Promise((resolve, reject) => {
      this._service.getItemswithParameter('v1',
          environment.accessPartner,
          environment.accessPartner,
          'applicationpermissiongroupconfig',
          null).subscribe(response => {
        if (response) {
          this.applicationPermissionConfig = response;
          resolve('success');
        } else {
          resolve('failed');
        }
      }, error => {
        resolve('failed');
      });
    });
  }

  getApplicationsForPartnerAccount() {
    return new Promise((resolve, reject) => {
      this.confPost.getData('services',
          'services',
          'v1',
          'application',
          'partner=' + localStorage.getItem('partner') +
          '&account=' + localStorage.getItem('account')).subscribe(async resp => {
        this.applicationData = resp;
        this.countOfApplications = this.applicationData.length;
        this.leftPanelDataListener.manageEntitiesUpdate.emit('application');
        resolve('success');
      }, error => {
        resolve('failed');
      });
    });
  }

  hasPlatformPermission(permission) {
    return this.accountInfoService.hasPermission(permission);
  }

  setMenusAfterPermissions() {
    for (const menuItem of this.menus) {
      if (menuItem) {
        for (const menu of menuItem['stickyMenus']) {
          if (menu) {
            switch (menu['name']) {
              case 'control-plane':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_CONTROL_PLANE');
                break;
              case 'creation':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_CREATE_NAVIGATION_PANE');
                break;
              case 'transform':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_TRANSFORM_NAVIGATION_PANE');
                break;
              case 'connect':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_INTEGRATE_NAVIGATION_PANE');
                break;
              case 'register':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_REGISTER_NAVIGATION_PANE');
                break;
              case 'reference':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_API_REFERENCE');
                break;
              case 'test':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_TEST_NAVIGATION_PANE');
                break;
              case 'learn':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_LEARN_NAVIGATION_PANE');
                break;
              case 'manage':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_MANAGE_NAVIGATION_PANE');
                break;
              case 'tools':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_TOOLS_NAVIGATION_PANE');
                break;
              case 'samples':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_SAMPLES');
                break;
              case 'settings':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_SETTINGS_NAVIGATION_PANE');
                break;
              case 'switch To ...':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_SWITCH_TO');
                break;
              case 'History':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_HISTORY');
                break;
              case 'partner-info':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_PARTNER_INFO_NAVIGATION_PANE');
                break;
              case 'api-discovery':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_API_DISCOVERY');
                break;
              case 'journey':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_JOURNEY_ANALYTICS');
                break;
              case 'billing':
                menu['hasPermission'] = this.hasPlatformPermission('MENU_BILLING');
                break;
              default:
                menu['hasPermission'] = false;
                break;
            }
          }
        }
      }
    }
  }

  getAllPermissions() {
    return new Promise((resolve, reject) => {
      if (!this.accountInfoService.hasPlatformPermissions()) {
        const dialogRef = this.dialog.open(InsufficientPermissionsToAccessComponent, {
          width: '75vh',
          height: 'auto',
        });
        dialogRef.afterClosed().subscribe(resp => {
          this.authService.logout();
        });
      }
      this.setMenusAfterPermissions();
      resolve('success');
    });
  }

  getPropertiesFromAPI() {
    return new Promise((resolve, reject) => {
      this.confPost.getDataFromServiceForPartnerAccount('properties', 'services', 'services').subscribe(props => {
        if (props) {
          this.properties = props[0]['properties'];
          resolve('success');
        } else {
          reject({error: 'No data'});
        }
      }, error => {
        reject(error);
      });
    });
  }

  openSnackBar(message: string, panelClass: string, config: any) {
    let snackBarConfigs: any;
    if (config !== null && config !== undefined && config !== '') {
      snackBarConfigs = config;
      snackBarConfigs['data'] = message;
      snackBarConfigs['panelClass'] = panelClass;
    } else {
      snackBarConfigs = {
        data: message,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: panelClass,
        duration: 30000
      };
    }
    this.snackBar.openFromComponent(SnackbarComponent, snackBarConfigs);
    // Duration and positions needs to be configurable
  }

  hasAccountPermission(permission) {
    return this.accountInfoService.hasPermission(permission);
  }

  getExecutorsForPartnerAccount() {
    return new Promise((resolve, reject) => {
      this.executorLoadingInLeftPanel = true;
      this.confPost.getApiExecutorsByPartnerAccount(localStorage.getItem('partner'),
          localStorage.getItem('account'),
          'partner=' + localStorage.getItem('partner') +
          '&account=' + localStorage.getItem('account') +
          '&fields=partner,account_id,executor_name,executor_version,executor_method_type,executor_type,executor_scope,executor_display_name,executor_category,service_provider,apiUrl,published,scopeOfAccess,registeredAsIs,creationTime,lastModifiedTime,executor_description,pathParams,queryParams,headers,authModel,requestBody,responseAttributes,isDocumentationPublished&limit=4000').toPromise().then(data => {
        const apiExecutors = [];
        const businessLogicExecutors = [];
        const sqlQueryExecutors = [];
        const unifiedQueryExecutors = [];
        const testSuiteExecutors = [];
        const workflowExecutors = [];
        const dmnExecutors = [];
        const plsqlExecutors = [];
        const dataTransformationExecutors = [];
        const thirdpartyExecutors = [];
        this.allExecutorsButDaaS = [];
        const partnerExecutors = [];
        this.leftpanelData = data;
        for (const executor of this.leftpanelData) {
          if (executor) {
            if (partnerExecutors.length === 0) {
              partnerExecutors.push({category: executor['executor_category'], executors: []});
            } else {
              if (partnerExecutors.findIndex((exec) => exec['category'] === executor['executor_category']) === -1) {
                partnerExecutors.push({category: executor['executor_category'], executors: []});
              }
            }
          }
        }
        const iterator = this.leftpanelData[Symbol.iterator]();
        while (true) {
          const tempObject = iterator.next();
          if (tempObject.done) {
            break;
          } else {
            partnerExecutors[partnerExecutors.findIndex((exec) =>
                exec['category'] === tempObject.value['executor_category'])]['executors'].push(tempObject.value);
          }
          if (tempObject.value['executor_type'] === 'API') {
            apiExecutors.push(tempObject.value);
          } else if (tempObject.value['executor_type'] === 'BUSINESSLOGIC') {
            businessLogicExecutors.push(tempObject.value);
          } else if (tempObject.value['executor_type'] === 'SQLQUERY') {
            sqlQueryExecutors.push(tempObject.value);
          } else if (tempObject.value['executor_type'] === 'UNIFIEDQUERY') {
            unifiedQueryExecutors.push(tempObject.value);
          } else if (tempObject.value['executor_type'] === 'TESTSUITE' || tempObject.value['executor_type'] === 'EXTERNALTESTSUITE') {
            testSuiteExecutors.push(tempObject.value);
          } else if (tempObject.value['executor_type'] === 'THIRDPARTY') {
            thirdpartyExecutors.push(tempObject.value);
          } else if (tempObject.value['executor_type'] === 'WORKFLOW') {
            workflowExecutors.push(tempObject.value);
          } else if (tempObject.value['executor_type'] === 'DMN') {
            dmnExecutors.push(tempObject.value);
          } else if (tempObject.value['executor_type'] === 'PLSQL') {
            plsqlExecutors.push(tempObject.value);
          } else if (tempObject.value['executor_type'] === 'DATATRANSFORMATION') {
            dataTransformationExecutors.push(tempObject.value);
          }
        }

        this.partnerExecutors = partnerExecutors;

        this.allExecutorsButDaaS = this.allExecutorsButDaaS.concat(businessLogicExecutors,
            sqlQueryExecutors,
            unifiedQueryExecutors,
            testSuiteExecutors,
            workflowExecutors,
            dmnExecutors,
            plsqlExecutors,
            dataTransformationExecutors);
        this.apiExecutors = [];
        for (const item of apiExecutors) {
          if (item) {
            if (this.hasAccountPermission('view:' +
                this.partner + '=>' +
                item.account_id + '=>' +
                item.executor_category +
                '=>' + item.executor_version)) {
              this.apiExecutors.push(item);
            }
          }
        }
        if (this.apiExecutors) {
          this.countOfApiExecutors = this.apiExecutors.length;
        }
        this.businessLogicExecutors = [];
        for (const item of businessLogicExecutors) {
          if (item) {
            if (this.hasAccountPermission('view:' +
                this.partner + '=>' +
                item.account_id + '=>' +
                item.executor_name + '=>' +
                item.executor_version)) {
              this.businessLogicExecutors.push(item);
            }
          }
        }
        if (this.businessLogicExecutors) {
          this.executors = this.businessLogicExecutors;
          this.countOfBusinessLogicApis = this.businessLogicExecutors.length;
        }
        this.thirdPartyApiExecutors = [];
        for (const item of thirdpartyExecutors) {
          if (item) {
            if (this.hasAccountPermission('view:' +
                this.partner + '=>' +
                item.account_id + '=>' +
                item.executor_name + '=>' +
                item.executor_version)) {
              this.thirdPartyApiExecutors.push(item);
            }
          }
        }
        if (this.thirdPartyApiExecutors) {
          this.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
        }
        this.sqlQueryExecutors = [];
        for (const item of sqlQueryExecutors) {
          if (item) {
            if (this.hasAccountPermission('view:' +
                this.partner + '=>' +
                item.account_id + '=>' +
                item.executor_name + '=>' +
                item.executor_version)) {
              this.sqlQueryExecutors.push(item);
            }
          }
        }
        if (this.sqlQueryExecutors) {
          this.countOfSqlQueryApis = this.sqlQueryExecutors.length;
        }

        this.dataTransformationExecutors = [];
        for (const item of dataTransformationExecutors) {
          if (item) {
            if (this.hasAccountPermission('view:' +
                this.partner + '=>' +
                item.account_id + '=>' +
                item.executor_name + '=>' +
                item.executor_version)) {
              this.dataTransformationExecutors.push(item);
            }
          }
        }
        if (this.dataTransformationExecutors) {
          this.countOfDataTransformationApis = this.dataTransformationExecutors.length;
        }

        this.unifiedQueryExecutors = [];
        for (const item of unifiedQueryExecutors) {
          if (item) {
            if (this.hasAccountPermission('view:' +
                this.partner + '=>' +
                item.account_id + '=>' +
                item.executor_name + '=>' +
                item.executor_version)) {
              this.unifiedQueryExecutors.push(item);
            }
          }
        }
        if (this.unifiedQueryExecutors) {
          this.countOfUnifiedQueryApis = this.unifiedQueryExecutors.length;
        }
        this.testSuiteExecutors = [];
        for (const item of testSuiteExecutors) {
          if (item) {
            if (this.hasAccountPermission('view:' +
                this.partner + '=>' +
                item.account_id + '=>' +
                item.executor_name + '=>' +
                item.executor_version)) {
              this.testSuiteExecutors.push(item);
            }
          }
        }
        if (this.testSuiteExecutors) {
          this.countOfTestSuiteApis = this.testSuiteExecutors.length;
        }
        this.workFlowExecutors = [];
        for (const item of workflowExecutors) {
          if (item) {
            if (this.hasAccountPermission('view:' +
                this.partner + '=>' +
                item.account_id + '=>' +
                item.executor_name + '=>' +
                item.executor_version)) {
              this.workFlowExecutors.push(item);
            }
          }
        }
        if (this.workFlowExecutors) {
          this.countOfWorkflowApis = this.workFlowExecutors.length;
        }
        this.dmnExecutors = [];
        for (const item of dmnExecutors) {
          if (item) {
            if (this.hasAccountPermission('view:' +
                this.partner + '=>' +
                item.account_id + '=>' +
                item.executor_name + '=>' +
                item.executor_version)) {
              this.dmnExecutors.push(item);
            }
          }
        }
        if (this.dmnExecutors) {
          this.countOfDmnApis = this.dmnExecutors.length;
        }
        this.plsqlExecutors = [];
        for (const item of plsqlExecutors) {
          if (item) {
            if (this.hasAccountPermission('view:' +
                this.partner + '=>' +
                item.account_id + '=>' +
                item.executor_name + '=>' +
                item.executor_version)) {
              this.plsqlExecutors.push(item);
            }
          }
        }
        if (this.plsqlExecutors) {
          this.countOfPlSqlApis = this.plsqlExecutors.length;
        }
        this.leftPanelDataListener.manageEntitiesUpdate.emit('update');

        this.executorLoadingInLeftPanel = false;
        resolve('success');
      }, error => {
        this.executorLoadingInLeftPanel = false;
        resolve('failed');
      });
    });
  }

  updateIsNoSQLForMongo(databasesParam) {
    return new Promise(async (resolve, reject) => {
      let databases: any;
      if (databasesParam.hasOwnProperty('databaseDetails')) {
        databases = databasesParam['databaseDetails'];
      } else {
        databases = databasesParam;
      }
      let isNoSQLFalseMatchFound = false;
      for (const database of databases) {
        if (database) {
          if ((database['database_type'] === 'mongodb' || database['database_type'] === 'dynamodb') && database['is_nosql'] === false) {
            isNoSQLFalseMatchFound = true;
            database['is_nosql'] = true;
          }
        }
      }
      this.databases = databases;
      resolve('success');
    });
  }

  getDefaultGatewaySettings(settingsData) {
    return new Promise((resolve, reject) => {
      for (const envs of settingsData['body'][0]['environments']) {
        if (envs && envs !== null && envs !== undefined) {
          if (envs['name'] === localStorage.getItem('partner')) {
            if (envs['services']) {
              const gatewayService = envs['services'].filter(element => element.type === 'apigateway');
              if(gatewayService && gatewayService.length > 0 && gatewayService[0]['configurations']) {
                for (const gateway of gatewayService[0]['configurations']) {
                  if (gateway && gateway !== null && gateway !== undefined && gateway['is_default'] === true && gateway['gateway_configurations'] !== {}) {
                    this.defaultGatewaySettings = gateway['gateway_configurations'];
                    this.selection = gateway['gateway_configurations'];
                    this.selectedAPIGateway = gateway;
                    this.selectedAPIGatewayName = gateway['name'];
                    resolve('success');
                  }
                }
             }
            }
          }
        }
      }
    });
  }

  patchEntityData(partner, account, version, entity, id, payload) {
    return new Promise((resolve, reject) => {
      this.confPost.patchEntityData(partner, account, version, entity, id, payload).subscribe(response1 => {
        resolve('success');
      }, error => {
        this.openSnackBar('Error while patching data for partner', 'Error', {
          duration: 15000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        resolve('failed');
      });
    });
  }

  patchDefaultGatewaySettingsAndInsert(id, environments) {
    return new Promise((resolve, reject) => {
      let withoutTypeFound = false;
      if (environments && environments !== null && environments !== undefined) {
        for (let i = 0; i < environments.length; i++) {
          if (environments[i] && environments[i] !== null && environments[i] !== undefined) {
            const gatewayService = environments[i]['services'].filter(element => element.type === 'apigateway');
            for (let j = 0; j < gatewayService.length; j++) {
              if (gatewayService[j] && gatewayService[j] !== null && gatewayService[j] !== undefined) {
                const gatewayServiceConfig = gatewayService[j]['configurations'][0];
                if (gatewayServiceConfig && !gatewayServiceConfig.hasOwnProperty('type')) {
                  withoutTypeFound = true;
                  gatewayServiceConfig['name'] = 'default';
                  gatewayServiceConfig['type'] = 'kong';
                  gatewayServiceConfig['gateway_configurations'] = [
                    {
                      'name': 'key-auth',
                      'isConfigured': false,
                      'img': '/assets/img/key-auth.png',
                      'description': 'Configure KeyAuth service..',
                      'enabled': true,
                      'consumer': {},
                      'tagline': 'Add Key Authentication (also referred to as an API key) to your APIs. Consumers then add their key either in a querystring parameter or a header to authenticate their requests.',
                      'config': [
                        {
                          'displayName': 'Key Names',
                          'parameter': 'key_names',
                          'type': 'array_string',
                          'value': 'apikey',
                          'isRequired': true,
                          'description': 'Describes an array of parameter names where the plugin will look for a key. The client must send the authentication key in one of those key names, and the plugin will try to read the credential from a header, request body, or query string parameter with the same name.\n' +
                              'Note: The key names may only contain [a-z], [A-Z], [0-9], [_] underscore, and [-] hyphen'
                        },
                        {
                          'displayName': 'Key In Body',
                          'parameter': 'key_in_body',
                          'type': 'boolean',
                          'value': false,
                          'isRequired': false,
                          'description': 'If enabled, the plugin reads the request body (if said request has one and its MIME type is supported) and tries to find the key in it. Supported MIME types: application/www-form-urlencoded, application/json, and multipart/form-data'
                        },
                        {
                          'displayName': 'Hide Credentials',
                          'parameter': 'hide_credentials',
                          'type': 'boolean',
                          'value': false,
                          'isRequired': false,
                          'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e., the header, query string, or request body containing the key) before proxying it'
                        },
                        {
                          'displayName': 'Run On Preflight',
                          'parameter': 'run_on_preflight',
                          'type': 'boolean',
                          'value': true,
                          'isRequired': false,
                          'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests are always allowed'
                        },
                        {
                          'displayName': 'Key In Header',
                          'parameter': 'key_in_header',
                          'type': 'boolean',
                          'value': true,
                          'isRequired': false,
                          'description': 'If enabled (default), the plugin reads the request header and tries to find the key in it'
                        },
                        {
                          'displayName': 'Key In Query',
                          'parameter': 'key_in_query',
                          'type': 'boolean',
                          'value': true,
                          'isRequired': false,
                          'description': 'If enabled (default), the plugin reads the query parameter in the request and tries to find the key in it'
                        },
                      ],
                      'id': 9,
                      'itemName': 'key-auth'
                    },
                    {
                      'name': 'cors',
                      'isConfigured': false,
                      'img': 'assets/img/cors.png',
                      'description': 'Configure CORS service.',
                      'tagline': 'Allow developers to make requests from the browser',
                      'enabled': true,
                      'consumer': {},
                      'config': [
                        {
                          'displayName': 'Origins',
                          'parameter': 'origins',
                          'type': 'array_string',
                          'value': '*',
                          'isRequired': false,
                          'description': 'List of allowed domains for the Access-Control-Allow-Origin header. If you want to allow all origins, add * as a single value to this configuration field. The accepted values can either be flat strings or PCRE regexes'
                        },
                        {
                          'displayName': 'Headers',
                          'parameter': 'headers',
                          'type': 'array_string',
                          'value': null,
                          'isRequired': false,
                          'description': 'Tip: Comma separated values for the Access-Control-Allow-Headers header, expects a comma delimited string (e.g. Origin, Authorization).'
                        },
                        {
                          'displayName': 'Exposed Headers',
                          'parameter': 'exposed_headers',
                          'type': 'array_string',
                          'value': null,
                          'isRequired': false,
                          'description': 'Tip: Comma separated values for the Access-Control-Expose-Headers header, expects a comma delimited string (e.g. Origin, Authorization). If not specified, no custom headers are exposed.'
                        },
                        {
                          'displayName': 'Methods',
                          'parameter': 'methods',
                          'type': 'array_string',
                          'value': null,
                          'isRequired': false,
                          'description': 'Value for the Access-Control-Allow-Methods header. Available options include GET, HEAD, PUT, PATCH, POST, DELETE, OPTIONS, TRACE, CONNECT. By default, all options are allowed'
                        },
                        {
                          'displayName': 'Max Age',
                          'parameter': 'max_age',
                          'type': 'number',
                          'value': 300,
                          'isRequired': false,
                          'description': 'Indicates how long the results of the preflight request can be cached, in seconds'
                        },
                        {
                          'displayName': 'Credentials',
                          'parameter': 'credentials',
                          'type': 'boolean',
                          'value': false,
                          'isRequired': true,
                          'description': 'Flag to determine whether the Access-Control-Allow-Credentials header should be sent with true as the value'
                        },
                        {
                          'displayName': 'Preflight Continue',
                          'parameter': 'preflight_continue',
                          'type': 'boolean',
                          'value': false,
                          'isRequired': true,
                          'description': 'A boolean value that instructs the plugin to proxy the OPTIONS preflight request to the Upstream service'
                        }
                      ],
                      'id': 11,
                      'itemName': 'cors'
                    },
                    {
                      'name': 'ip-restriction',
                      'isConfigured': false,
                      'img': 'assets/img/ip-restriction.png',
                      'description': 'Configure IP Restriction service.',
                      'tagline': 'Whitelist or blacklist IPs that can make requests',
                      'enabled': false,
                      'consumer': {},
                      'config': [
                        {
                          'displayName': 'Allow',
                          'parameter': 'allow',
                          'type': 'array_string',
                          'value': '127.0.0.1',
                          'description': 'Tip: Comma separated list of IPs or CIDR ranges to whitelist. At least one between whitelist or blacklist must be specified.'
                        },
                        {
                          'displayName': 'Deny',
                          'parameter': 'deny',
                          'type': 'array_string',
                          'value': null,
                          'description': 'Tip: Comma separated list of IPs or CIDR ranges to blacklist. At least one between whitelist or blacklist must be specified.'
                        }
                      ],
                      'id': 12,
                      'itemName': 'ip-restriction'
                    },
                    {
                      'name': 'rate-limiting',
                      'isConfigured': false,
                      'img': '/assets/img/rate-limiting.png',
                      'description': 'Configure Rate limiting service.',
                      'enabled': true,
                      'consumer': {},
                      'tagline': ' Rate limit how many HTTP requests a developer can make in a given period of seconds, minutes, hours, days, months or years. If the API has no authentication layer, the Client IP address will be used, otherwise the Consumer will be used if an authentication plugin has been configured.',
                      'config': [
                        {
                          'displayName': 'Second',
                          'parameter': 'second',
                          'type': 'number',
                          'value': null,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per second'
                        },
                        {
                          'displayName': 'Minute',
                          'parameter': 'minute',
                          'type': 'number',
                          'value': 5,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per minute'
                        },
                        {
                          'displayName': 'Hour',
                          'parameter': 'hour',
                          'type': 'number',
                          'value': null,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per hour'
                        },
                        {
                          'displayName': 'Day',
                          'parameter': 'day',
                          'type': 'number',
                          'value': null,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per day'
                        },
                        {
                          'displayName': 'Month',
                          'parameter': 'month',
                          'type': 'number',
                          'value': null,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per month'
                        },
                        {
                          'displayName': 'Year',
                          'parameter': 'year',
                          'type': 'number',
                          'value': null,
                          'isRequired': false,
                          'description': 'The number of HTTP requests that can be made per year'
                        },
                        {
                          'displayName': 'Limit By',
                          'parameter': 'limit_by',
                          'type': 'string',
                          'value': 'consumer',
                          'isRequired': false,
                          'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip, service, header, path. If the value for the entity chosen to aggregate the limit cannot be determined, the system will always fallback to ip. If value service is chosen, the service_id configuration must be provided. If value header is chosen, the header_name configuration must be provided. If value path is chosen, the path configuration must be provided'
                        },
                        {
                          'displayName': 'Policy',
                          'parameter': 'policy',
                          'type': 'string',
                          'value': 'local',
                          'isRequired': false,
                          'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n' +
                              '\n' +
                              'In Konnect Cloud, the default policy is redis'
                        },
                        {
                          'displayName': 'Fault Tolerant',
                          'parameter': 'fault_tolerant',
                          'type': 'boolean',
                          'value': true,
                          'isRequired': false,
                          'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
                        },
                        {
                          'displayName': 'Hide Client Headers',
                          'parameter': 'hide_client_headers',
                          'type': 'boolean',
                          'value': false,
                          'isRequired': false,
                          'description': 'Optionally hide informative response headers'
                        },
                        {
                          'displayName': 'Redis Host',
                          'parameter': 'redis_host',
                          'type': 'string',
                          'value': 'localhost',
                          'isRequired': false,
                          'description': 'When using the redis policy, this property specifies the address to the Redis server'
                        },
                        {
                          'displayName': 'Redis Password',
                          'parameter': 'redis_password',
                          'type': 'string',
                          'value': '',
                          'isRequired': false,
                          'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
                        },
                        {
                          'displayName': 'Redis Port',
                          'parameter': 'redis_port',
                          'type': 'number',
                          'value': 6379,
                          'isRequired': false,
                          'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379'
                        },
                        {
                          'displayName': 'Redis Timeout',
                          'parameter': 'redis_timeout',
                          'type': 'number',
                          'value': 2000,
                          'isRequired': false,
                          'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
                        },
                        {
                          'displayName': 'Redis Database',
                          'parameter': 'redis_database',
                          'type': 'number',
                          'value': 0,
                          'isRequired': false,
                          'description': 'When using the redis policy, this property specifies the Redis database to use'
                        }
                      ],
                      'id': 18,
                      'itemName': 'rate-limiting'
                    }
                  ];
                  const url = gatewayServiceConfig['url'];
                  gatewayServiceConfig['url'] = [url];
                  gatewayServiceConfig['config'] = {
                    'protocol': 'https',
                    'host': environment.adminGatewayHost,
                    'port': environment.adminPort
                  };
                }
              }
            }
          }
        }
        if (withoutTypeFound === true) {
          const payload = {
            environments: environments
          };
          this.patchEntityData('services', 'services', 'v2', 'settings', id, payload).then(response => {
            resolve('success');
          });
        } else {
          resolve('success');

        }
      } else {
        resolve('failed');
      }
    });
  }

  checkForAdminInSettingsV1AndInsert(settingsPayload) {
    const environments = settingsPayload['environments'];
    const temp = this.partner.split('-');
    let partnerShortCode = '';
    if (temp.length > 1) {
      partnerShortCode = temp[temp.length - 1];
    } else {
      partnerShortCode = temp[0];
    }
    this.confPost.getSettingsV2CRUD('admin-' + partnerShortCode, 'admin-' + partnerShortCode, false).subscribe(response => {
      if (response['body'] && response['body'][0]) {
        response['body'][0]['environments'].push(environments[0]);
        this.confPost.patchEntityData('services',
            'services',
            'v2',
            'settings',
            response['body'][0]['id'],
            response['body'][0]).subscribe(response1 => {

        }, error => {
          this.openSnackBar('Error while patching admin data for partner', 'Error', {
            duration: 15000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        });
      }
    }, error => {
      this.openSnackBar('Error while fetching admin data for partner', 'Error', {
        duration: 15000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  constructAndInsertSettingsPayload() {
    this.settingsPayloadToInsert.partner = this.partner;
    this.settingsPayloadToInsert.account = this.account;
    this.settingsPayloadToInsert.email = localStorage.getItem('signInEmail');
    const env = this.partner.split('-');
    if (env.length > 1) {
      this.settingsPayloadToInsert.environments[0].type = env[0];
    } else {
      this.settingsPayloadToInsert.environments[0].type = 'prod';
    }
    this.settingsPayloadToInsert.environments[0].name = localStorage.getItem('partner');
    const platformServices = new Promise((resolve, reject) => {
      this.confPost.getData('services',
          'services',
          'v1',
          'platformServices',
          '').subscribe(response => {
        const iterator = response[Symbol.iterator]();
        while (true) {
          const tempObject = iterator.next();
          if (tempObject.done) {
            break;
          }
          this.settingsPayloadToInsert.subscriptions.platform_services.push(tempObject.value.id);
        }
        resolve('success');
      }, error => {
        resolve('failed');
      });
    });

    const platformServiceCategories = new Promise((resolve, reject) => {
      this.confPost.getData('services', 'services', 'v1', 'platformServiceCategories', '').subscribe(response => {
        const iterator = response[Symbol.iterator]();
        while (true) {
          const tempObject = iterator.next();
          if (tempObject.done) {
            break;
          }
          this.settingsPayloadToInsert.subscriptions.platform_service_categories.push(tempObject.value.id);
        }
        resolve('success');
      }, error => {
        resolve('failed');
      });
    });

    Promise.all([platformServices, platformServiceCategories]).then(response4 => {
      this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        this.settingsPayloadToInsert.phone_number = data['primary_phone'];
        if (data['logo'] === null) {
          this.settingsPayloadToInsert.logo = '';
        } else {
          this.settingsPayloadToInsert.logo = data['logo'];
        }
        if (data['brandImage'] === null) {
          this.settingsPayloadToInsert.brand_image = '';
        } else {
          this.settingsPayloadToInsert.brand_image = data['brandImage'];
        }
        const databaseConfigurations = [];
        data['databases'].forEach(database => {
          const databaseService = database;
          if (database['name'] === 'Default') {
            databaseService['is_default'] = true;
          } else {
            databaseService['is_default'] = false;
            database['shash'] = data['shash'];
            database['ralam'] = data['ralam'];
          }
          databaseService['audit_logs'] = [];
          const audit_log = {
            action: 'CREATE',
            by: localStorage.getItem('signInEmail'),
            at: Date.now()
          };
          databaseService['audit_logs'].push(audit_log);
          databaseConfigurations.push(databaseService);
        });
        for (let i = 0; i < this.settingsPayloadToInsert.environments[0].services.length; i++) {
          if (this.settingsPayloadToInsert.environments[0].services[i].type === 'databases') {
            this.settingsPayloadToInsert.environments[0].services[i].configurations = databaseConfigurations;
          }
        }
        this._service.addItem(this.settingsPayloadToInsert, 'v2', 'services', 'services', 'settings').subscribe(response => {
          if (this.settingsPayloadToInsert.environments[0].type !== 'admin') {
            this.checkForAdminInSettingsV1AndInsert(this.settingsPayloadToInsert);
          }
          this.settingsPayloadToInsert['id'] = response['upsertedId'];
          const tempSettings = {
            body: []
          };
          tempSettings.body.push(this.settingsPayloadToInsert);
          this.settingsData = tempSettings;
        }, error => {
          const errorMessage = 'Welcome username, we recently upgraded our platform that needs your settings and preferences updated in our platform. It is an automated action and there is no action to be taken from your side. But the automated action has failed due to some reasons. Please report this to apiplatform administrator.';
        });
      }, error => {
        const databaseConfigurations = [];
        for (let i = 0; i < this.settingsPayloadToInsert.environments[0].services.length; i++) {
          if (this.settingsPayloadToInsert.environments[0].services[i].type === 'databases') {
            this.defaultDatabaseConfiguration.audit_logs[0].at = Date.now();
            databaseConfigurations.push(this.defaultDatabaseConfiguration);
            this.settingsPayloadToInsert.environments[0].services[i].configurations = databaseConfigurations;
          }
        }
        this._service.addItem(this.settingsPayloadToInsert, 'v2', 'services', 'services', 'settings').subscribe(response => {
          this.settingsPayloadToInsert['id'] = response['upsertedId'];
          const tempSettings = {
            body: []
          };
          tempSettings.body.push(this.settingsPayloadToInsert);
          this.settingsData = tempSettings;
        }, error => {
          const errorMessage = 'Welcome username, we recently upgraded our platform that needs your settings and preferences updated in our platform. It is an automated action and there is no action to be taken from your side. But the automated action has failed due to some reasons. Please report this to apiplatform administrator.';
        });
      });
    });
  }

  getEntity(val) {
    const data = val.split('#');
    return data[0];
  }

  getVersion(val) {
    const data = val.split('#');
    return data[1];
  }

  setPermissionsForSubcategories() {
    if (this.JSONData && this.JSONData.hasOwnProperty('subcategory')) {
      for (const category of this.JSONData['subcategory']) {
        if (category && category.hasOwnProperty('categoryName')) {
          switch (category['categoryName']) {
            case 'Data as a Service':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_ACCESS_API');
              break;
            case 'Application Logic':
              category['hasPermission'] = this.hasPlatformPermission('MENU_BUSINESS_LOGIC_API');
              break;
            case 'SQL as a Service':
              category['hasPermission'] = this.hasPlatformPermission('MENU_QUERY_BUILDER_API');
              break;
            case 'API Joins':
              category['hasPermission'] = this.hasPlatformPermission('MENU_QUERY_BUILDER_API');
              break;
            case 'PLSQL as a Service':
              category['hasPermission'] = this.hasPlatformPermission('MENU_PLSQL_API');
              break;
            case 'Data as a Service (Advanced)':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_ACCESS_API_ADVANCED');
              break;
            case 'Workflows':
              category['hasPermission'] = this.hasPlatformPermission('MENU_WORKFLOW_API');
              break;
            case 'Decisions':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DMN_API');
              break;
            case 'Test Suite as a Service':
              category['hasPermission'] = this.hasPlatformPermission('MENU_TEST_SUITE_API');
              break;
            case 'API Tester':
              category['hasPermission'] = this.hasPlatformPermission('MENU_API_TESTER');
              break;
            case 'APIQL Engine':
              category['hasPermission'] = this.hasPlatformPermission('MENU_APIQL');
              break;
            case 'DATAQL Engine':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DATAQL');
              break;
            case 'API Collection':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DATAQL');
              break;
            case 'Test Suite Results':
              category['hasPermission'] = this.hasPlatformPermission('MENU_TEST_RESULTS');
              break;
            case 'API Providers':
              category['hasPermission'] = this.hasPlatformPermission('MENU_SERVICE_PROVIDERS');
              break;
            case 'API Provider Categories':
              category['hasPermission'] = this.hasPlatformPermission('MENU_SERVICE_PROVIDER_CATEGORIES');
              break;
            case 'Accelerators':
              category['hasPermission'] = this.hasPlatformPermission('MENU_ACCELERATORS');
              break;
            case 'API Tester/Registrar':
              category['hasPermission'] = this.hasPlatformPermission('MENU_API_TESTER');
              break;
            case 'API Register':
              category['hasPermission'] = this.hasPlatformPermission('MENU_API_REGISTER');
              break;
            case 'Postman Collection':
              category['hasPermission'] = true;
              break;
            case 'Email Template Builder':
              category['hasPermission'] = this.hasPlatformPermission('MENU_EMAIL_TEMPLATE_BUILDER');
              break;
            case 'Scheduler':
              category['hasPermission'] = this.hasPlatformPermission('MENU_SCHEDULER');
              break;
            case 'Trigger':
              category['hasPermission'] = this.hasPlatformPermission('MENU_SCHEDULER');
              break;
            case 'Data Catalog':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_CATALOG');
              break;
            case 'File Manager':
              category['hasPermission'] = this.hasPlatformPermission('MENU_FILE_MANAGER');
              break;
            case 'Alerts':
              category['hasPermission'] = this.hasPlatformPermission('MENU_ALERTS');
              break;
            case 'Business Details':
              category['hasPermission'] = this.hasPlatformPermission('MENU_BUSINESS_DETAILS');
              break;
            case 'Database Connectors':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DATABASES');
              break;
            case 'Business Locations':
              category['hasPermission'] = this.hasPlatformPermission('MENU_BUSINESS_LOCATIONS');
              break;
            case 'Branding':
              category['hasPermission'] = this.hasPlatformPermission('MENU_BRANDING');
              break;
            case 'API Management':
              category['hasPermission'] = this.hasPlatformPermission('MENU_API_MANAGEMENT');
              break;
            case 'Manage Email Configurations':
              category['hasPermission'] = this.hasPlatformPermission('MENU_EMAIL_CONFIGURATIONS');
              break;
            case 'Consumer Gateway Settings':
              category['hasPermission'] = this.hasPlatformPermission('MENU_CONSUMER_GATEWAY_SETTINGS');
              break;
            case 'Manage Users':
              category['hasPermission'] = this.hasPlatformPermission('MENU_MANAGE_USERS');
              break;
            case 'Manage User Groups':
              category['hasPermission'] = this.hasPlatformPermission('MENU_MANAGE_USER_GROUPS');
              break;
            case 'Idle Timeout Settings':
              category['hasPermission'] = this.hasPlatformPermission('MENU_IDLE_TIMEOUT_SETTINGS');
              break;
            case 'Design2API':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DATABASES');
              break;
            case 'Data2API':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_CATALOG');
              break;
            case 'COBOL2API':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DATABASES');
              break;
            case 'Data Transformation':
              category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_TRANFORMATION_API');
              break;
            default:
              if (this.JSONData && this.JSONData.hasOwnProperty('category') && this.JSONData.category === 'environments') {
                category['hasPermission'] = true;
              } else {
                category['hasPermission'] = false;
              }
              break;
          }
        }
      }
    }
  }

  handleErrorGracefully(error, customMessage) {
    if (error) {
      if (error.error) {
        let errorMessage = '';
        if (error.error.error) {
          errorMessage = error.error.error;
        } else if (error.error.message) {
          errorMessage = error.error.message;
        } else if (error.error.body) {
          errorMessage = error.error.body;
        } else {
          errorMessage = error.error;
        }
        this.openSnackBar(errorMessage, 'Error', {
          duration: 15000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else if (error.body) {
        this.openSnackBar(JSON.stringify(error.body), 'Error', {
          duration: 15000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else if (error.message) {
        this.openSnackBar(JSON.stringify(error.message), 'Error', {
          duration: 15000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else {
        this.openSnackBar(customMessage, 'Error', {
          duration: 15000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else {
      this.openSnackBar(customMessage, 'Error', {
        duration: 15000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  generateActionPayload(isError, eventname, logLevel, responseStatusCode, responseStatus, errorMessage, payload, response, slug) {
    return new Promise((resolve, reject) => {
      const actionPayloadForAudit = {
        data: {}
      };
      actionPayloadForAudit['timestamp'] = Date.now();
      actionPayloadForAudit['standardTime'] = this.appComponent.timeConverter(Date.now());
      actionPayloadForAudit['eventName'] = eventname;
      actionPayloadForAudit['logLevel'] = logLevel;
      actionPayloadForAudit['responseStatusCode'] = responseStatusCode;
      actionPayloadForAudit['responseStatus'] = responseStatus;
      actionPayloadForAudit['data']['payload'] = payload;
      actionPayloadForAudit['data']['response'] = response;
      actionPayloadForAudit['slug'] = slug;
      actionPayloadForAudit['user'] = localStorage.getItem('signInEmail');
      if (isError) {
        actionPayloadForAudit['errorMessage'] = errorMessage;
      }
      this.appComponent.actionsOfCurrentSession.push(actionPayloadForAudit);
      resolve(this.appComponent.actionsOfCurrentSession);
    });
  }

  generateActionPayloadForAudit(isError, eventname, logLevel, responseStatusCode, responseStatus, errorMessage, payload, response, slug) {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  returnErrorMessage(error) {
    return this.appComponent.returnErrorMessage(error);
  }

  // Frontend
  hignlightSelection(index, id, menus) {
    let flagid: any;
    for (let i = 0; i < menus.length; i++) {
      if ($('#' + id + i).hasClass('selectedClass')) {
        flagid = i;
        $('#' + id + i).removeClass('selectedClass');
      }
    }
    if (index !== flagid) {
      $('#' + id + index).addClass('selectedClass');
    }

  }

  showDetails(category) {
    this.settingsflag = false;
    if (this.subMenu) {
      if (this.selectedMenu === category) {
        this.subMenu = false;
        this.appComponent.subMenuPanelExpanded = false;
        this.appComponent.leftMenuPanelExpanded = 'col-md-1 col-lg-1 sideBarCollapsed';
      }
    } else {
      this.subMenu = true;
      this.appComponent.subMenuPanelExpanded = true;
      this.appComponent.leftMenuPanelExpanded = 'col-md-2 col-lg-2';
    }
    this.selectedMenu = category;
    this.JSONData = $(this.masterData).filter(function (i, n) {
      if (n && n['category']) {
        return n['category'] === category;
      }
    });
    this.JSONData = this.JSONData['0'];
    if (category === 'Data Access API') {
      this.SideMenuNavigationUrl = '/api';
      const tempArrayOfJSON = [];
      for (let i = 0; i < this.categories.length; i++) {
        const tempJSON = {};
        const subCategoryArray = [];
        tempJSON['categoryName'] = this.categories[i].category;
        tempJSON['route'] = null;
        for (let j = 0; j < this.categories[i].entities.length; j++) {
          const subCategory = {};
          subCategory['categoryName'] = this.getEntity(this.categories[i].entities[j]);
          subCategory['route'] = this.SideMenuNavigationUrl + '?partner=' + this.partner +
              '&account=' + this.account +
              '&entity=' + this.getEntity(this.categories[i].entities[j]) + '&version=' + this.getVersion(this.categories[i].entities[j]);
          subCategoryArray.push(subCategory);
        }
        tempJSON['subCategory'] = subCategoryArray;
        tempArrayOfJSON.push(tempJSON);
      }
      this.JSONData['subcategory'] = tempArrayOfJSON;
    } else if (category === 'Developer Experience') {
      this.SideMenuNavigationUrl = '/devex';
      const tempArrayOfJSON = [];
      for (let i = 0; i < this.categories.length; i++) {
        const tempJSON = {};
        const subCategoryArray = [];
        tempJSON['categoryName'] = this.categories[i].category;
        tempJSON['route'] = null;
        for (let j = 0; j < this.categories[i].entities.length; j++) {
          const subCategory = {};
          subCategory['categoryName'] = this.getEntity(this.categories[i].entities[j]);
          subCategory['route'] = this.SideMenuNavigationUrl + '?partner=' + this.partner +
              '&account=' + this.account +
              '&entity=' + this.getEntity(this.categories[i].entities[j]) + '&version=' + this.getVersion(this.categories[i].entities[j]);
          subCategoryArray.push(subCategory);
        }
        tempJSON['subcategory'] = subCategoryArray;
        tempArrayOfJSON.push(tempJSON);
      }
      if (this.JSONData) {
        this.JSONData['subcategory'] = tempArrayOfJSON;
      }
    } else if (category === 'manage') {
      this.JSONData['subcategory'] = this.allExecutorsButDaaS;
    } else if (category === 'History') {
      this.JSONData['subcategory'] = this.apiHistory;
    } else if (category === 'creation') {
      this.JSONData = $(this.masterData).filter(function (i, n) {
        if (n && n['category']) {
          return n['category'] === category;
        }
      });
      this.JSONData = this.JSONData['0'];
    } else if (category === 'Business Logic API') {
      this.SideMenuNavigationUrl = '/devex';
    } else if (category === 'Workflow API') {
      this.SideMenuNavigationUrl = '/devex';
    } else if (category === 'SQL Query API') {
      this.SideMenuNavigationUrl = '/devex';
    } else if (category === 'Third Party API') {
      this.SideMenuNavigationUrl = '/devex';
    }

    this.setPermissionsForSubcategories();
    this.appComponent.SidePanelCheck = true;
  }

  hasSubMenuFalse() {
    this.subMenu = false;
    this.appComponent.subMenuPanelExpanded = false;
  }

  closePanel(menus, id) {
    this.settingsflag = false;
    this.subMenu = false;
    this.appComponent.subMenuPanelExpanded = false;
    this.appComponent.leftMenuPanelExpanded = 'col-md-1 col-lg-1 sideBarCollapsed';
    let flagid: any;
    for (let i = 0; i < menus.length; i++) {
      if ($('#' + id + i).hasClass('selectedClass')) {
        flagid = i;
        $('#' + id + i).removeClass('selectedClass');
      }
    }
  }

  toUpper(val) {
    return val.toUpperCase();
  }

  getMenu(val) {
    if (val != null) {
      return val.replace(/ /g, '');
    } else {
      return 'Default';
    }

  }

  toggleExecutor(ev, id) {
    $(id).slideToggle();
    $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
  }

  getMethodName(method, entityname) {
    return method.toLowerCase() + entityname;
  }

  hasPermissions(permissions) {
    return this.accountInfoService.hasPermissions(permissions);
  }

  // SET UP LEFTPANEL

  setMenu() {
    let envMenu = [];
    envMenu = JSON.parse(JSON.stringify(this.adminMenu));
    envMenu[1].submenu.splice(0, 2);
    envMenu[2].submenu.splice(0, 1);
    envMenu[4].submenu.splice(0, 1);
    envMenu[5].submenu.splice(0, 1);
    envMenu = envMenu.filter((v, i) => v.name !== 'Development Environments' && v.name !== 'Billing');
    this.menu = envMenu;
  }

  redirect(route: string) {
    this.router.navigate([route]);
  }

  getData(selectedEnvironment) {
    this.setMenu();
    if (this.environments) {
      const filteredAdminMenu = this.adminMenu.map((menu) => {
        if (menu.name === 'API Security Management') {
          const updatedSubmenu = menu.submenu.filter(
              (submenu) => submenu.name !== 'Gateway Settings'
          );
          return { ...menu, submenu: updatedSubmenu };
        }
        if (menu.name === 'Platform Experience')
          {
            const updatedSubmenu = menu.submenu.filter(
                (submenu) => submenu.name !== 'API Gateway'
            );
            return { ...menu, submenu: updatedSubmenu };
        }
        if (menu.name === 'Productivity Tools')
          {
            const updatedSubmenu = menu.submenu.filter(
                (submenu) => submenu.name !== 'S3 Connectors'
            );
            return { ...menu, submenu: updatedSubmenu };
        }
        
          
        if (menu.name === 'General') {
          const updatedSubmenu = menu.submenu.filter(
              (submenu) => submenu.name !== 'Idle Timeout'
          );
          return { ...menu, submenu: updatedSubmenu };
        }
        return menu;
      });
      for (let i = 0; i < this.environments.length; i++) {
        this.menuPanel[i] = this.environments[i]['type'] === 'admin' ? JSON.parse(JSON.stringify(filteredAdminMenu)) : JSON.parse(JSON.stringify(this.menu));
      }
      this.selectedEnvironmentIndex = this.environments.findIndex(environment => environment.name === selectedEnvironment['env']);
      this.selectedEnvironmentData = this.menuPanel[this.selectedEnvironmentIndex];
    }
  }

  setUpLeftPanelMenu() {
    this.selectedEnvironment = this.adminEnvironmentHandler.currentEnvironment;
    this.getData(this.selectedEnvironment);
    if (this.selectedMenu) {
      this.updateMenuItems();
    }
    this.adminEnvironmentHandler.onEnvironmentChange.subscribe(async env => {
      this.selectedEnvironment = this.adminEnvironmentHandler.currentEnvironment;
      this.getData(this.selectedEnvironment);
      if (this.selectedMenu) {
        this.updateMenuItems();
      }
    });
  }

  updateMenuItems() {
    const menuItems = this.selectedEnvironmentData.filter((item) => item.name === this.selectedMenu);
    if (menuItems) {
      if (menuItems[0]) {
        this.setMenuItems(menuItems[0]);
      } else {
        this.closePanel(this.menuItems[0]['submenu'], 'adminMenu');
      }
    }
  }

  setMenuItems(menuItems) {
    this.menuItems = menuItems;
  }

  // Initialize Platform

  async initialisePlatform() {
    this.partner = localStorage.getItem('partner');
    this.account = localStorage.getItem('account');
    this.gatewayUrl = await this.getDefaultGatewayURL();
    Promise.resolve(this.getEnvironments().then(res => {
      this.setEnvironmentData();
      this.setUpLeftPanelMenu();
    }));
    this.setEnvironmentsToSettingsPayloadToInsert();
    this.loadingForTheFirstTime = false;
    return new Promise(async (resolve, reject) => {
      this.progressMessage = 'Getting your environments';
      const partnerTempArray = localStorage.getItem('partner').split('-');
      let partnerShortCode: string;
      if (partnerTempArray.length > 1) {
        partnerShortCode = partnerTempArray[partnerTempArray.length - 1];
      } else {
        partnerShortCode = partnerTempArray[0];
      }
      const partnerShortCodeInPartnerInfo = this.partnerInfo.filter(elem => elem['title'] === 'Partner Short Code');
      if (partnerShortCodeInPartnerInfo && partnerShortCodeInPartnerInfo.length > 0) {
        partnerShortCodeInPartnerInfo[0]['value'] = partnerShortCode;
      }

      if (this.partner && this.account) {
        this.isDataInitialised.emit(false);

        this.getApplicationPermissionGroupConfig();

        const getPermissions = new Promise(async (resolve, reject) => {
          await this.getAllPermissions();
          resolve('success');
        });

        const getProperties = new Promise(async (resolve, reject) => {
          if (this.properties === null || this.properties === undefined) {
            (this.getPropertiesFromAPI()).then(resp => {
              resolve('success');
            });
          } else {
            resolve('failed');
          }
        });

        const getOAuthCreds = new Promise((resolve, reject) => {
          this.kong.getKongGatewayConsumerDetails(localStorage.getItem('signInEmail')).subscribe((data) => {
            const consumerResponse = data['data'][0];
            this.consumerId = consumerResponse['id'];
            this.kong.getKongGatewayCredentialDetails('oauth2', this.consumerId).subscribe(response1 => {
              if (response1 && response1['data']) {
                this.OAuthClientApps = response1['data'];
                resolve('success');
              }
            });
          });
        });

        const getAPIKey = new Promise((resolve, reject) => {
          this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(localStorage.getItem('signInEmail')).subscribe(keys => {
            this.apiKeyData = keys;
            if (this.apiKeyData.data !== null && this.apiKeyData.data !== undefined && this.apiKeyData.data.length !== 0) {
              this.apiKeys = this.apiKeyData.data;
              this.apiKey = this.apiKeys[0].key;
              localStorage.setItem('apikey', this.apiKey);
              const apiKeyInPartnerInfo = this.partnerInfo.filter(elem => elem['title'] === 'API Key');
              if (apiKeyInPartnerInfo && apiKeyInPartnerInfo.length > 0) {
                apiKeyInPartnerInfo[0]['value'] = this.apiKey;
              }
            }
            resolve('success');
          }, error => {
            this.openSnackBar('There is no API key associated to your user credentials. ' +
                'Please get an API Key to securely access your APIs.',
                'Info'
                , {
                  duration: 10000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
            resolve('failed');
          });
        });

        const getEnvironmentsOfPartner = new Promise((resolve, reject) => {
          this.confPost.getData('services',
              'services',
              'v1',
              'apiHistory',
              'partner=' + this.partner + '&account=' + this.account + '&sort=-at&fields=at,executor_name,executor_type,by,executor_version,partner,account,action').subscribe(response => {
            if (response && response !== null && response !== undefined && response[0]) {
              this.apiHistory = response;
              const masterDataPayload = {
                'category': 'History',
                'expand': true,
                'route': null,
                'subcategory': []
              };
              this.masterData.push(masterDataPayload);

              const partnerInfoIndex = this.menus[1].stickyMenus.findIndex(value => value['name'] === 'partner-info');
              const historyData = {
                name: 'History',
                displayName: 'History',
                tooltipText: 'Shows history of API Executors',
                hasSubMenu: true,
                displayType: '',
                icon: 'fa fa-clock-o',
                submenus: []
              };
              if (partnerInfoIndex !== -1) {
                this.menus[1].stickyMenus.splice(partnerInfoIndex, 0, historyData);
              } else {
                this.menus[1].stickyMenus.push(historyData);
              }
              for (const item of this.menus[1].stickyMenus) {
                if (item['name'] === 'History') {
                  item['hasPermission'] = this.hasPlatformPermission('MENU_HISTORY');
                }
              }
              this.setMenusAfterPermissions();
              this.isHistoryAvailable = true;
            }
          });
        });

        const getEntitiesPartnerAccount = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving your entities...';
          this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'),
              localStorage.getItem('account')).toPromise().then(data1 => {
            this.entities = data1;
            this.partnerEntities = data1;
            this.partnerEntities.forEach(entity => {
              this.partnerEntityTypes.push(entity.entityname + '_' + entity.version);
            });
            this.progressMessage = 'Retrieving your entities...Done';
            this.progress = this.progress + this.incr;
            resolve('success');
          }, error => {
            this.progress = this.progress + this.incr;
            resolve('failure');
            this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
              duration: 30000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          });
        });

        const getExecutorsForPartnerAccount = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving your APIs...';
          this.getExecutorsForPartnerAccount().then(resp => {
            this.progressMessage = 'Retrieving your APIs...Done';
            this.progress = this.progress + this.incr;
            resolve('success');
          });
        });

        const getApplicationsForPartnerAccount = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving your Applications...';
          this.getApplicationsForPartnerAccount().then(resp => {
            this.progressMessage = 'Retrieving your Applications...Done';
            this.progress = this.progress + this.incr;
            resolve('success');
          });
        });

        const getLanguages = new Promise((resolve, reject) => {
          this.confPost.getLanguages().subscribe(
              items => {
                this.languages = items;
                resolve('success');
              },
              error => {
                resolve('failure');
                this.openSnackBar('Error while getting list of languages: ' + error.error.message, 'Error', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              }
          );

        });

        const getCategoriesForPartnerAccount = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving your data access service categories...';
          if (this.partnerCategories === null || this.partnerCategories === undefined) {
            this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
              this.partnerCategories = data;
              this.progressMessage = 'Retrieving your data access service categories...Done';
              this.progress = this.progress + this.incr;
              resolve('success');
            }, error => {
              this.progress = this.progress + this.incr;
              resolve('failure');
              this.openSnackBar('Error while retrieving data access services group by categories for your account', 'Error', {
                duration: 30000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            });
          }
        });

        const getDatabasesForPartnerAccount = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving your configured databases...';
          this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(async databases => {
                this.databases = databases;
                await this.updateIsNoSQLForMongo(this.databases);
                this.progressMessage = 'Retrieving your configured databases...Done';
                this.progress = this.progress + this.incr;
                resolve('success');
              },
              error => {
                this.progress = this.progress + this.incr;
                resolve('failure');
                this.openSnackBar('Error while getting list of databases: ' + error.error.message, 'Error', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const getDataTypesForPartnerAccount = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving your configured datatypes...';
          this.confPost.getDataTypes().subscribe(data => {
                this.datatypes = data;
                this.progressMessage = 'Retrieving your configured datatypes...Done';
                this.progress = this.progress + this.incr;
                resolve('success');
              },
              error => {
                this.progress = this.progress + this.incr;
                resolve('failure');
                this.openSnackBar('Error while getting list of data types: ' + error.error.message, 'Error', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const getAPIGateways = new Promise((resolve1, reject1) => {
          this.progressMessage = 'Retrieving your configured API Gateways...';
          this.confPost.getPartnerSettings(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey')).subscribe(data => {
                let resp: any;
                resp = data;
                this.apiGateways = resp['apigateway'];
                this.progressMessage = 'Retrieving your configured API Gateways...Done';
                this.progress = this.progress + this.incr;
                resolve1('success');
              },
              error => {
                this.progress = this.progress + this.incr;
                resolve1('failure');
                this.openSnackBar('Error while getting list of API Gateways: ' + error.error.message, 'Error', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const getEntityCountForPartner = new Promise((resolve, reject) => {
          this.confPost.getEntityCountForPartner(localStorage.getItem('partner')).subscribe(data => {
                this.countPartnerEntities = data;
                this.progress = this.progress + this.incr;
                resolve('success');
              },
              error => {
                this.progress = this.progress + this.incr;
                resolve('failure');
                this.openSnackBar('Error while getting count of entities for partner: ' + error.error.message, 'Error', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const getCategoriesEntitiesForPartner = new Promise((resolve, reject) => {
          this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'),
              localStorage.getItem('account')).subscribe(data => {
            this.categoriesEntitiesForPartner = data;
            this.progress = this.progress + this.incr;
            resolve('success');
          }, error => {
            this.progress = this.progress + this.incr;
            resolve('failure');
            this.openSnackBar('Error while getting entities grouped by category for partner account: ' + error.error.message, 'Error', {
              duration: 30000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          });
        });

        const getDatabaseObjectTypes = new Promise((resolve, reject) => {
          this.confPost.getDatabaseObjectTypes().subscribe(data => {
            this.databaseObjectTypes = data;
            resolve('success');
          }, error => {
            resolve('failure');
          });
        });

        const b2bAPIs = new Promise((resolve, reject) => {
          this.providerObjects = {};
          this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'),
              localStorage.getItem('account'), true).subscribe(async response => {
            if (response['body'] && response['body'][0]) {
              const providers = response['body'][0]['subscriptions']['providers'];
              const subscribedProviders = [];
              const myServiceProviders = [];
              providers.forEach(provider => {
                if (provider.partner === localStorage.getItem('partner') &&
                    provider.account === localStorage.getItem('account')) {
                  myServiceProviders.push(provider['producer']);
                } else {
                  subscribedProviders.push(provider['producer']);
                }
                this.providerObjects[provider['producer']] = provider['title'];
              });
              let subscribedProvidersList = '';
              for (let i = 0; i < subscribedProviders.length; i++) {
                subscribedProvidersList += subscribedProviders[i];
                if (i !== subscribedProviders.length - 1) {
                  subscribedProvidersList += ',';
                }
              }
              let myProvidersList = '';
              for (let i = 0; i < myServiceProviders.length; i++) {
                myProvidersList += myServiceProviders[i];
                if (i !== myServiceProviders.length - 1) {
                  myProvidersList += ',';
                }
              }
              if (subscribedProvidersList !== '') {
                await this.confPost.getSubscribedExecutors('b2b', 'b2b', subscribedProvidersList).subscribe(response1 => {
                  this.b2bExecutors = response1;
                  resolve('success');
                }, error => {
                  reject('failed');
                });
              } else {
                resolve('success');
              }

              if (myProvidersList !== '') {
                await this.confPost.getMyProviderExecutors(localStorage.getItem('partner'),
                    localStorage.getItem('account'),
                    myProvidersList).subscribe(response1 => {
                  this.myProviderExecutors = response1;
                  resolve('success');
                }, error => {
                  reject('failed');
                });
              } else {
                resolve('success');
              }
            } else {
              resolve('failure');
            }
          }, error => {
            resolve('failure');
          });
        });

        const getMaxApiLimitForPartner = new Promise((resolve, reject) => {
          this.confPost.getMaxAPILimit(localStorage.getItem('partner')).subscribe(count => {
                this.maxCount = count;
                this.progress = this.progress + this.incr;
                resolve('success');
              },
              error => {
                resolve('failure');
                this.openSnackBar('Error while getting maximum API count for partner: ' + error.error.message, 'Error', {
                  duration: 15000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const authorizationTypes = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving Authorization types...';
          this._service.getItems('v1', 'services', 'services', 'authorizationTypes', false).subscribe(authTypes => {
                this.authorizationTypes = authTypes;
                this.progressMessage = 'Retrieving Authorization types...Done';
                resolve('success');
              },
              error => {
                resolve('failure');
                this.openSnackBar('Error while getting authorization types for partner account: ' + error.error.message, 'Error', {
                  duration: 15000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const platformServiceProviders = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving Service Providers master...';
          this.confPost.getData('services',
              'services',
              'v1',
              'apiproducers',
              'partner=services' + '&account=services').subscribe(platformProviders => {
                this.platformServiceProviders = platformProviders;
                this.progressMessage = 'Retrieving Service Providers master...Done';
                resolve('success');
              },
              error => {
                resolve('failure');
                this.openSnackBar('Error while getting list of service providers for platform: ' + error.error.message, 'Error', {
                  duration: 15000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const partnerServiceProviders = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving your subscribed service providers...';
          this.confPost.getData('services',
              'services',
              'v1',
              'apiproducers',
              'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account')).subscribe(partnerProviders => {
                this.partnerServiceProviders = partnerProviders;
                this.progressMessage = 'Retrieving your subscribed service providers...Done';
                this.progress = this.progress + this.incr;
                resolve('success');
              },
              error => {
                this.progress = this.progress + this.incr;
                resolve('failure');
                this.openSnackBar('Error while getting list of service providers for partner: ' + error.error.message, 'Error', {
                  duration: 15000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const settingsData = new Promise((resolve1, reject1) => {
          this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'),
              localStorage.getItem('account'), false).subscribe(async settingsData => {
                if (settingsData['body'] && settingsData['body'][0]) {
                  this.settingsData = settingsData;
                  this.partnerLogo = this.settingsData['body'][0]['logo'];
                  this.getDefaultGatewaySettings(this.settingsData);

                  for (const envs of this.settingsData['body'][0]['environments']) {
                    if (envs && envs !== null && envs !== undefined) {
                      if (envs['name'] === localStorage.getItem('partner')) {
                        if (envs['services']) {
                          const gatewayService = envs['services'].filter(element => element.type === 'apigateway');
                          if(gatewayService && gatewayService.length > 0 && gatewayService[0]['configurations']) {
                            for (const gateway of gatewayService[0]['configurations']) {
                              if (gateway && gateway !== null && gateway !== undefined && gateway['is_default'] === true && gateway['gateway_configurations'] !== {}) {
                                this.defaultGatewaySettings = gateway['gateway_configurations'];
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  await this.patchDefaultGatewaySettingsAndInsert(settingsData['body'][0]['id'], settingsData['body'][0]['environments']);
                  resolve1('success');
                } else {
                  resolve1('failure');
                  this.constructAndInsertSettingsPayload();
                }
              },
              error => {
                resolve1('failure');
                this.openSnackBar('Error while getting list of settings data for partner: ' + error.error.message, 'Error', {
                  duration: 15000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const settingsDataWithoutDBRef = new Promise((resolve, reject) => {
          this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'),
              localStorage.getItem('account'), true).subscribe(settingsData => {
                if (settingsData['body'] && settingsData['body'][0]) {
                  this.settingsDataWithoutDBRef = settingsData;
                  resolve('success');
                } else {
                  resolve('failure');
                }
              },
              error => {
                resolve('failure');
                this.openSnackBar('Error while getting list of settings data for partner: ' + error.error.message, 'Error', {
                  duration: 15000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const registeredConnectors = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving your configured API Connectors...';
          this.confPost.getData('services', 'services', 'v1', 'apiconnectors', 'partner=' + this.partner + '&account=' + this.account)
              .toPromise().then(apiconnectors => {
                this.registeredConnectors = apiconnectors;
                this.progressMessage = 'Retrieving your configured API Connectors...Done';
                this.progress = this.progress + this.incr;
                resolve('success');
              },
              error => {
                this.progress = this.progress + this.incr;
                resolve('failure');
                this.openSnackBar('Error while getting authorization types for partner account: ' + error.error.message, 'Error', {
                  duration: 15000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        const queryBuilderAttributes = new Promise((resolve, reject) => {
          this.progressMessage = 'Retrieving your Query Builder Attributes...';
          this.confPost.getAttributesForQueryBuilder(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(db => {
                this.queryBuilderAttributes = db;
                this.progressMessage = 'Retrieving your Query Builder Attributes...Done';
                resolve('success');
              },
              error => {
                resolve('failure');
                this.openSnackBar('Error while getting query builder attributes for partner account: ' + error.error.message, 'Error', {
                  duration: 15000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
        });

        Promise.all([getCategoriesEntitiesForPartner, getApplicationsForPartnerAccount,
          getEntitiesPartnerAccount, getExecutorsForPartnerAccount, getDataTypesForPartnerAccount,
          getEntityCountForPartner, getCategoriesForPartnerAccount,
          authorizationTypes, settingsDataWithoutDBRef, getDatabaseObjectTypes,
          registeredConnectors, queryBuilderAttributes, platformServiceProviders,
          partnerServiceProviders, settingsData, getAPIKey, b2bAPIs]).then(response => {
          this.isDataInitialised.emit(true);
          this.progressMessage = 'Setting up your workspace...';
          this.loadingForTheFirstTimeCompleted = true;
          this.leftPanelLoading = false;
          this.progressMessage = '';
          this.progress = 100;
          resolve('success');
        });
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  // ngOnInit Function

  async ngOnInit() {
    this.keySize = this.keySize / 32;
    this.appComponent.isSignUp = false;

    this.confPost.getData(
        'services',
        'services',
        'v1',
        'databaseConfigurations',
        null).subscribe(response => {
      if (response && response[0]) {
        this.databasesMeta = response;
      } else {
        this.databasesMeta = this.databasesMetaDefault;
      }
    }, error => {
      this.databasesMeta = this.databasesMetaDefault;
    });

    this.getCurrentSession();

    $(document).ready(function () {
      $('#myInput').on('keyup', function () {
        const value = $(this).val().toString().toLowerCase();
        $('.connectorone').filter(function () {
          $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
          return true;
        });
      });
    });

    if (localStorage.getItem('partner') === 'linkzy') {
      let resumeParserPayload = {};
      let subCategory = [];
      for (const category of this.masterData) {
        if (category['category'] === 'tools') {
          subCategory = category['subcategory'];
          resumeParserPayload = {
            categoryName: 'Parser',
            route: '/parser',
            icon: 'fa fa-angle-double-right'
          };
          subCategory.push(resumeParserPayload);
          category['subcategory'] = subCategory;
        }
      }
    }

    setTimeout(() => {
      if (this.loadingForTheFirstTime === true && this.loadingForTheFirstTimeCompleted === false) {
        this.loadingForTheFirstTime = false;
        this.initialisePlatform();
      }
    }, 500);

    this.appComponent.userName = (localStorage.getItem('partner') ? localStorage.getItem('partner') : 'Guest');
    this.userName = (localStorage.getItem('partner') ? localStorage.getItem('partner') : 'Guest');

    this.router.events.subscribe(event => {
      this.route = this.location.path();
      if (this.route.includes('/devex')) {
        this.SideMenuNavigationUrl = '/devex';
      } else {
        this.SideMenuNavigationUrl = '/api';
      }
    });
    if (this.location.path() !== '') {
      this.route = this.location.path();
      if (this.route.includes('/devex')) {
        this.SideMenuNavigationUrl = '/devex';
      } else {
        this.SideMenuNavigationUrl = '/api';
      }
    }

    this.basicPermission = true;
  }

}
